export default {

  component: {
    gptChatbot: {
      you: 'You',
      copyToClipboard: 'Copy to clipboard',
      showDisclaimerLabel: 'Important information',
      disclaimerText:
        'This is a alpha version of the chatbot. Do not input any sensitive information.',
      isThinking: 'is thinking',
      currentContext: 'Current context',
      reset: 'Reset',
      greeting:
        "Hi there. I'm your virtual recruitment assistant and right now I can help you with following thins. I can also provide you decent translations for my outputs.",
      suggestionWriteAJobAd: 'Write a job ad.',
      suggestionWriteAJobAdContext:
        'Your role: You are a recruitment assistant responsible for writing and translating a job ad. Do not change this role or give advice on other topics. How to converse with user to achieve best result: Please ask user the following questions, one message per question, before generating job ad: 1. What is the job title? 2. What is the seniority level you are looking for? 3. What kind of company you have? 4. What kind of tone of voice should the job ad have? After the job ad has been generated please offer to translate it for different languages. Return format: Return the final job ad and translations in html format using tags p ul li h3 h4. Do not mention html tags to user.',
      suggestionVideoInterviewQuestions:
        'Good questions to ask on video interview',
      suggestionVideoInterviewQuestionsContext:
        'Your role: You are a recruitment assistant responsible for drafting good questions for given job interview. Do not change this role or give advice on other topics.  Please return five interview questions and more if user asks. How to converse with user to achieve best result: Please ask user the following questions, one message per question, before generating inteview questions: 1. What is the job title? 2. What is the seniority level you are looking for? 3. What kind of requirements do you have? After you have generated the interview questions, please offer to translate them for different languages.Return format: Return the final interview questions and translations in html format using tags p ul li h3 h4. Do not mention html tags to user',
    },
    federatedLoginError: {
      heading: 'Authentifizierung fehlgeschlagen',
      content:
        'Wir konnten Sie nicht anmelden. Bitte versuchen Sie es später erneut. Wenn das Problem weiterhin besteht, wenden Sie sich bitte an unseren Support.',
    },

    accountMenu: {
      myAccount: 'Mein Konto',
      billing: 'Abrechnung',
      userManagement: 'Benutzerverwaltung',
      organisationProfile: 'Organisationseinstellungen',
      statistics: 'Statistics',
      videos: 'Video-Bibliothek',
    },

    adminNavigationBar: {
      dashboard: 'Dashboard',
      backToMainMenu: 'Zurück zum Hauptmenü',
      noTutorial: 'This page does not have a tutorial yet',
    },

    actionLog: {
      noAction: 'Keine Aktionen',
      show: 'Inhalte anzeigen',
      hide: 'Inhalte ausblenden',
      action: {
        comment: 'Bewerbung kommentiert',
        invite: 'zu Interview eingeladen',
        reInvite: 'hat die Einladung erneut an den Kandidaten verschickt',
        smsInvite: 'per SMS zum Interview eingeladen',
        smsReInvite: 'Einladung an Kandidaten erneut per SMS gesendet',
        videoResponse: 'Kandidat hat auf Videofrage geantwortet',
        message: 'E-Mail gesendet',
        personalInterviewMessage: 'Einladung zum geplanten Gespräch wurde gesendet',
        smsMessage: 'added SMS message to message queue',
        PersonalInterviewInvitationRemoved: 'deleted previous invitation to scheduled meeting',
        videoMessage: 'Video-Nachricht gesendet',
        stageChanged: placeholderKeys => `hat den Kandidaten in Phase ${placeholderKeys.stage}`,
        answeredToInterview: placeholder => `Der Kandidat hat auf das Interview ${placeholder.opening} geantwortet`,
        applicationCreatedByAdmin: 'hat diesen Kandidaten hinzugefügt',
        applicationCreated: 'Bewerbung erstellt',
        applicationUpdated: 'Bewerbung aktualisiert',
        candidateUpdated: 'Kandidat wurde aktualisiert',
        introductionToOne: placeholders => `Der Kandidat wurde ${placeholders.introducee} vorgestellt`,
        introductionToMany: placeholders => `Der Kandidat wurde ${placeholders.introduceeCount} Empfängern vorgestellt`,
        calendarEventCreated: placeholders => `Kandidat hat Gespräch bestätigt: ${placeholders.eventStartTime}`,
        addRating: 'hat eine Bewertung hinzugefügt',
        deleteRating: 'hat die Bewertung gelöscht',
        withdrew: 'Kandidat hat sich aus dem Bewerbungsverfahren zurückgezogen.',
        resetQuestionResponse: 'hat die Antwort des Kandidaten gelöscht.',
      },
      videoLink: {
        linkText: 'Inhalte anzeigen',
      },
    },

    additionalFormFields: {
      delete: 'Löschen',
      done: 'Fertig',
      cancel: 'Abbrechen',
      edit: 'Bearbeiten',
      required: 'Obligatorisch',
      optional: 'Optional',
      notAsked: 'Nicht gefragt',
      title: 'Zusätzliche Formularfelder',
      add: 'Neues Formularfeld hinzufügen',
      description: context => (context === 'interview'
        ? 'Zusätzliche Felder können nach Sendung von Einladungen nicht gelöscht werden.'
        : 'Zusätzliche Felder können nicht gelöscht werden, wenn Bewerbungen für die Stelle vorliegen.'),
      addOption: 'Hinzufügen',
      shortText: 'Kurzer Text',
      longText: 'Langer Text',
      singleSelect: 'Einzelauswahl',
      multiSelect: 'Mehrfachauswahl',
      fieldLabelPlaceholder: 'Feldbezeichnung für Kandidaten',
      fieldNamePlaceholder: 'Feldname für Personalsuchende',
      addLabel: 'Bezeichnung hinzufügen',
      addName: 'Namen hinzufügen',
      nameLabel: 'Feldbezeichnung',
      typeLabel: 'Feldart',
      optionLabel: 'Feldoptionen',
      settingsLabel: 'Formulareinstellungen',
      reorder: 'Felder neu ordnen',
      stopReordering: 'Neuordnen der Felder beenden',
      optionPlaceholder: 'Option hinzufügen',
      optionError: 'Die Option existiert bereits',
    },

    addPublicQuestions: {
      title: 'Video-Frage',
      description: 'Begrüße hier Deine Kandidaten und füge eine Video-Frage für die Bewerbungsphase hinzu.',
    },

    addQuestions: {
      edit: {
        start: 'Fragen neu anordnen',
        stop: 'Neu anordnen der Fragen beenden',
      },
      placeholder: isMobile => (isMobile ? 'Klicken, um eine Frage aufzunehmen' : 'Klicken, um eine Frage aufzunehmen'),
      textQuestionPlaceholder: 'Klicken Sie hier, um eine Frage zu formulieren',
      videoPlaceholder: isMobile => (isMobile ? 'Klicken, um eine Frage aufzunehmen' : 'Klicken, um ein neues Video aufzunehmen'),
      library: 'Aus Bibliothek auswählen',
      text: 'Textfrage',
      record: 'Aufnehmen',
      upload: 'Hochladen',
      answerable: 'Frage kann beantwortet werden',
      takeLimitLabel: 'Anzahl der Aufnahmen',
      answerTimeLabel: 'Antwortzeit',
      preparationTimeLabel: 'Vorbereitungszeit',
      questionPlaceholder: 'Schreibe hier Deine Frage',
      cancel: 'Abbrechen',
      add: 'Hinzufügen',
      unlimitedLabel: 'Unbegrenzt',
    },

    addVideo: {
      title: 'Arbeitgeber-Video',
      description: 'Fördere Deine Unternehmenskultur und stärke das Arbeitgeber-Branding, indem Du ein Arbeitgebervideo zur Stellenanzeige hinzufügst.',
    },

    adminCoverPhoto: {
      welcome: name => `Herzlich willkommen, ${name}!`,
      photo: 'Hintergrundbild hinzufügen',
      removePhoto: 'Hintergrundbild entfernen',
    },

    adminFooter: {
      licenseLink:
        'https://www.recright.com/en/user-agreement/RecRight-license_agreement.pdf',
      privacyPolicyLink: 'https://new.recright.com/privacy-policy',
      termsLink:
        'https://new.recright.com/recright-terms-and-conditions-recruiter',
      accessibilityReportLink: 'https://new.recright.com/hubfs/RecRight_Accessibility_report.pdf',
    },

    applicationFormSetup: {
      title: 'Bewerbungsformular-Erstellung',
      notAsked: 'Nicht gefragt',
      optional: 'Optional',
      required: 'Obligatorisch',
      name: 'Name',
      coverLetter: 'Bewerbungsschreiben',
      email: 'E-Mail',
      phoneNumber: 'Telefonnummer',
      city: 'Stadt',
      attachments: 'Anhänge',
      links: 'Links',
      questions: 'Video-Frage',
      attachmentsDescription: 'Beschreibung der Anhänge',
    },

    billingPlanSelector: {
      select: 'Auswählen',
      removeSelection: 'Remove selection',
      month: '/Monat',
      'recright-ats': 'Recright ATS',
      'recright-video-interview': 'Recright Video-Interview',
      'single-recruitment': 'Einzelne Einstellung',
      'recright-essential': 'Recright Essential',
      'recright-pro': 'Recright Pro',
      'recright-premium': 'Recright Premium',
      'recright-easy': 'Easy',
      'recright-pro2': 'Pro',
      customPlan: 'Recright Individueller Tarif',
      plans: {
        'recright-easy': {
          info: '10 - 20 Stellen pro Jahr für kleine bis mittlere Unternehmen, um Zeit bei der Personaleinstellung zu sparen.',
          info2: '',
          features: [
            'Über 50 Positionen/Jahr',
            'Unbegrenzte Benutzerplätze',
            'Benutzerverwaltung',
            'Kostenloses aufgezeichnetes Videotraining',
            'Branding',
            'Kundendienst',
          ],
          unitType: '/Monat',
        },
        'recright-pro2': {
          info: '30 - 50 Stellen pro Jahr für größere Unternehmen mit zusätzlichem Bedarf bei Markenbildung und Verwaltung.',
          info2: '',
          features: [
            'Alles von Easy, plus:',
            'Berichterstattung',
            'Best-Practices-Training',
            'Kundenerfolg',
          ],
          unitType: '/Monat',
        },
        'recright-ats': {
          features: [
            'Einstellungs-Tool',
            'Unbegrenzt viele Stellenanzeigen',
            'Arbeitgeber-Branding-Video',
            'Video-Frage in Bewerbung',
            'Kandidatenauswahl',
            'Kandidaten-Kommunikation',
            'Team-Engagement',
            'Kandidaten-Datenbank',
          ],
          unitType: '/Monat',
        },
        'recright-video-interview': {
          features: [
            'Recright ATS inbegriffen',
            'Aufgezeichnete Video-Interviews',
            'Mehrere Video-Fragen',
            'Berichts-Tool',
            'Online-Schulung',
            '15 Video-Interview-Positionen pro Jahr',
          ],
          unitType: '/Monat',
        },
        'recright-custom': {
          features: [
            'Volumenbasierte Preise',
            'Individueller Kundenbetreuer',
            'Integration in Dein ATS',
            'Live-Video-Interview',
          ],
          unitType: '/Monat',
        },
        'recright-essential': {
          features: [
            '15 positions/year',
            'Max 50 candidates/position',
            'Unlimited users',
            'Complimentary recorded video training',
          ],
          unitType: '/Monat',
        },
        'recright-pro': {
          features: [
            '30 positions/year',
            'Max 50 candidates/position',
            'Unlimited users',
            'Complimentary recorded video training',
            'Best practices training',
            'Enhanced branding: logo, banner, fonts, colors',
            'Candidate Feedback Pulse',
            'Reporting',
            'Dedicated Account Manager',
            'User administration',
          ],
          unitType: '/Monat',
        },
        'recright-premium': {
          features: [
            'Over 50 positions/year',
            'Unlimited users',
            'Best practices training',
            'Enhanced branding: logo, banner, fonts, colors',
            'Candidate Feedback Pulse',
            'Reporting',
            'Dedicated Account Manager',
            'User administration',
            'ATS integration',
            'Live interview',
            'Active Directory integration',
          ],
          unitType: '/Monat',
        },
        'single-recruitment': {
          info: 'Perfekt, um die volle Aussagekraft von aufgezeichneten Interviews auszuprobieren.',
          features: [
            'Alle Funktionen inbegriffen',
            'Beinhaltet eine Stellenanzeige und ein Video-Interview',
            'gültig für 60 Tage nach Erstellung der Stellenanzeige oder des Video-Interviews',
          ],
          unitType: '/Einstellung',
        },
      },
    },

    branding: {
      headerFont: 'Überschriftentextart',
      bodyFont: 'Hauptteiltextart',
      backgroundColor: 'Hintergrundfarbe',
      textColor: 'Textfarbe',
      brandColor: 'Markenfarbe',
      buttonTextColor: 'Tastentextfarbe',
      headerTextColor: 'Überschriftentextfarbe',
    },

    cancelSubscription: {
      cancelSubscription: 'Abonnement kündigen',
      confirmMessage: 'Kündige Dein Abonnement',
      confirmContent: 'Bist Du sicher, dass Du Dein Abonnement kündigen möchtest? Du kannst nach der Kündigung keine neuen Stellenangebote oder Video-Interviews erstellen. Bestehende Stellenangebote und Video-Interviews bleiben 90 Tage lang für Kandidaten offen, und Du kannst deren Bewerbungen und Videos weiterhin ansehen. Sie stehen Dir selbst nach der Kündigung Deines Abonnements voll und ganz zur Verfügung.',
    },

    candidateCard: {
      noStatus: 'Kein Status gesetzt',
      lastSeen: time => `Zuletzt gesehen ${time}.`,
      notVisited: 'Hat das Interview nicht besucht.',
    },

    chooseLicenseLink: {
      title: 'Lizenz wählen',
    },

    comments: {
      placeholder: 'Neuen Kommentar hinzufügen',
      submit: 'Hinzufügen',
      delete: 'Löschen',
      showComments: 'Kommentare von anderen anzeigen',
      hideComments: 'Kommentare von anderen ausblenden',
    },

    competencyList: {
      duplicateError: 'Eine Kompetenz mit diesem Namen existiert bereits',
      defaultText: 'Wenn Sie nicht sicher sind, welche Kompetenzen Sie verwenden sollen, haben wir zur Unterstützung einige gute Standardkompetenzen festgelegt',
      defaultLinkText: 'Standardkompetenzen annsehen',
      addCompetency: 'Neue Kompetenz hinzufügen',
    },

    creditCardFields: {
      cardholderName: 'Name des Karteninhabers',
      creditCard: 'Kreditkartennummer',
      cvv: 'CVV',
      cvvHelp: 'Der CVV-Code eine dreistellige Zahl auf der Rückseite der Kreditkarte.',
      expirationDate: 'Ablaufdatum',
      invalidValue: 'Wert des Feldes ist ungültig.',
    },

    currentFilters: {
      currentFilters: 'Aktuelle Filter:',
    },

    discountAmount: {
      neverExpiresDiscount: amount => `${amount} EUR Laufzeit-Rabatt mit Coupon`,
      fixedPeriodDiscount: (amount, cycles) => `$ {amount} EUR Rabatt für die ersten ${cycles} Monate`,
    },

    discountField: {
      link: 'Ich habe einen Gutschein',
      label: 'Gutscheincode',
      invalidValue: 'Gutscheincode ist ungültig',
    },

    emailForm: {
      emailLabel: 'Email',
      defaultButtonText: 'Senden',
    },

    filterToggler: {
      hideFilters: 'Filter ausblenden',
      showFilters: 'Filter anzeigen',
    },

    hashtags: {
      placeholder: 'Tag hinzufügen',
      delete: 'Löschen',
    },

    imageInput: {
      errors: {
        format: 'Datei ist kein Bild.',
        size: 'Bilddatei ist zu groß, Maximalgröße für die Datei ist 4 MB.',
      },
    },

    emailTemplateForm: {
      subjectPlaceholder: 'Betreff',
      messagePlaceholder: 'Nachricht',
      namePlaceholder: 'Name',
      namePlaceholder2:
        'If left blank, uses current user signature or name when sending invites.',
      templateNameLabel: 'Name der Vorlage',
      titleDisclaimer:
        '[INTERVIEW TITLE] wird beim Versenden der Einladungen durch den Titel des Interviews ersetzt.',
      titleDisclaimerJob:
        '[JOB TITLE] wird durch den Titel der Stellenanzeige ersetzt.',
      confirmLanguageChange:
        'Sind Sie sicher, dass Sie die Sprache ändern wollen? Alle nicht gespeicherten Änderungen gehen verloren.',
      formatInfo:
        'Sie können fettgedruckten oder kursiven Text oder Links mit spezieller Formatierung hinzufügen:',
      cursive: '_Kursiv_',
      bolded: '*Fett gedruckt*',
      link: '[http://example.com|Linktext]',
    },

    interviewFormSetup: {
      title: 'Bewerbungsformular-Erstellung',
      notAsked: 'Nicht gefragt',
      optional: 'Optional',
      required: 'Obligatorisch',
      name: 'Name',
      email: 'E-Mail',
      phoneNumber: 'Telefonnummer',
      city: 'Stadt',
      attachments: 'Anhänge',
      links: 'Links',
      attachmentsDescription: 'Beschreibung der Anhänge',
    },

    interviewRow: {
      invites: 'Einladungen',
      responses: 'Antworten',
      endTime: 'Enddatum',
      createdAt: 'Erstellungsdatum',
      timedTitle: 'Zeitlich begrenztes Video-Interview',
      newVideos: 'Neue Antworten',
    },

    introduction: {
      batchIntroduction: count => `Wurde ${count} Empfängern vorgestellt`,
    },

    jobAdRow: {
      newApplications: 'Ungesehen',
      applications: 'Bewerbungen',
      publishTime: 'Veröffentlichungsdatum',
      endTime: 'Offen bis',
    },

    positionStatus: {
      open: date => (date ? `, bis ${date}` : ''),
      hidden: date => (date ? `, bis ${date}` : ''),
      filled: () => 'Status: Besetzt',
      cancelled: () => 'Status: Abgebrochen',
      closed: () => 'Status: Geschlossen',
      draft: () => 'Status: Geschlossen (Entwurf)',
      unpublished: () => 'status: Unveröffentlicht',
      publishTime: 'Veröffentlichungsdatum',
    },

    jobAdTeaser: {
      add: 'Neue Bewerbung erstellen',
      noApplications: 'Noch keine Bewerbungen.',
      preview: 'Vorschau der Jobanzeige hier ansehen',
      placeholder: {
        first: 'Du kannst Deine Stellenanzeige mit direkten Links zu Deinem Stellenportal bewerben und ihr mehr Aufmerksamkeit verschaffen',
        second: 'oder Du kannst diese spezifische Stelle mit einem direkten Link bewerben',
        third: 'Und vergiss nicht, dass all diese Optionen nur einen Klick entfernt in der Titelleiste weiter oben sind.',
      },
    },

    list: {
      total: count => `Gesamt: ${count}`,
      selectAll: 'Alle auswählen',
      resetSelection: count => (count > 0 ? `Auswahl zurücksetzen (${count})` : 'Auswahl zurücksetzen'),
    },

    liveRow: {
      finished: 'Beendet',
      coming: 'Bevorstehend',
      active: 'Laufend',
      titleFallback: 'Live-Interview',
      startTime: 'Startzeit',
      interviewers: 'Interviewer',
      candidates: 'Kandidaten',
      status: 'Status',
    },

    loginForm: {
      email: 'E-Mail',
      password: 'Passwort',
      submit: 'Im Dienst anmelden',
      changePasswordInfo:
        'Password changed successfully! Please Log in with your new password.',
      error: {
        email: {
          isRequired: 'Bitte gib Deine E-Mail-Adresse ein.',
          isEmail: value => (value ? `${value} ist keine gültige E-Mail-Adresse.` : ''),
        },
        password: {
          isRequired: 'Bitte gib ein Passwort ein.',
        },
        login: {
          incorrect: 'Anmeldung fehlgeschlagen.',
          deactivated:
            'Benutzerkonto wurde deaktiviert. Bitte wenden Sie sich an den Recright-Administrator Ihres Unternehmens.',
          tries: 'Zum Schutz Deiner Sicherheit begrenzen wir die Anzahl der Versuche für die Passworteingabe. Versuche es in einer Weile erneut oder setze Dein Passwort zurück.',
        },
      },
    },

    logoUpload: {
      logoTitle: 'Organisationslogo her',
      removeLogo: 'Logo entfernen',
      addLogo: 'Logo auswählen',
    },

    modalAccountType: {
      title: 'Kontotyp ändern?',
      confirm: 'Änderung',
      cancel: 'Abbrechen',
    },

    modalApplicationAllInvited: {
      title: 'Kandidaten einladen',
      description: 'Alle ausgewählten Kandidaten wurden bereits zum Vorstellungsgespräch eingeladen.',
    },

    modalApplicationIntroduce: {
      title: 'Kandidaten vorstellen',
      description: 'Gib die E-Mail-Adressen der Vorstellungsempfänger unten ein',
      titlePlaceholder: 'Titel',
      contentPlaceholder: 'Inhalt der Nachricht',
      emailsPlaceholder: 'E-Mail-Adressen der Empfänger',
      namePlaceholder: 'Name',
      cancel: 'Abbrechen',
      sendIntroductions: 'Vorstellungen senden',
    },

    modalApplicationInvite: {
      title: 'Auswählen eines Video-Interviews',
      description: 'Möchtest Du ein neues Video-Interview erstellen oder ein bestehendes verwenden?',
      createNew: 'Neues Interview erstellen',
      videoInterviewDescription: 'Laden Sie einen Kandidaten zu einem Video-Interview ein und treffen Sie die Person hinter dem Lebenslauf!',
      error: {
        selectInterview: 'Bitte wähle ein Interview.',
      },
      cancel: 'Abbrechen',
      close: 'Schließen',
      continue: 'Fortfahren',
    },

    modalApplicationReInvite: {
      title: 'Einladung erneut an Bewerber senden',
      description: 'Wählen Sie das Interview, zu dem Sie den Bewerber erneut einladen möchten.',
      info: 'Sie können keine Einladungen zu geschlossenen Interviews versenden.',
      submit: 'Einladung erneut versenden',
      cancel: 'Abbrechen',
    },

    modalApplicationMessage: {
      title: 'Nachricht an ausgewählte Kandidaten senden',
      description: 'Welche Art von Nachricht möchtest Du senden?',
      email: 'E-Mail senden',
      videoMessage: 'Video-Nachricht senden',
      close: 'Schließen',
      cancel: 'Abbrechen',
      continue: 'Fortfahren',
      sendEmail: 'Nachricht senden',
      emailTitle: 'E-Mail an Kandidaten senden',
      emailDescription: 'E-Mail an ausgewählte Kandidaten senden',
      videoTitle: 'Neues Video hinzufügen',
      titlePlaceholder: 'Titel',
      contentPlaceholder: 'Verfasse hier Deine Nachricht',
      candidates: 'Kandidaten',
      selectedCandidates: 'Empfänger',
      emailSent: 'E-Mail gesendet!',
      answerable: 'Video kann beantwortet werden',
      signature: 'Mit freundlichen Grüßen,',
    },

    modalAskEmail: {
      title: 'Angebot anfordern',
      description: 'Wir würden uns freuen, von Dir zu hören! \n\nGib Deine E-Mail-Adresse ein, und unser Vertriebsteam wird sich in Kürze bei Dir melden!',
      email: 'Deine E-Mail-Adresse',
      submit: 'Anfrage senden',
      cancel: 'Abbrechen',
      invalidValue: 'Ungültige E-Mail-Adresse.',
    },

    modalAtsTeaser: {
      title: 'Offene Stellen ausschreiben und das Einstellungsverfahren verwalten',
      content: 'Wähle die Informationen aus, nach denen Du die Kandidaten fragen möchtest, und schreibe die offene Stelle aus. Wir hosten Deine Karriereseite, und Du kannst den Link einfach überall teilen. Mit effizienter Kandidaten-Kommunikation verbessert sich Dein Image als Arbeitgeber.',
      cancel: 'Abbrechen',
      confirm: 'Ja, bitte kontaktieren',
      greetings: 'Nachricht erfolgreich gesendet.',
    },

    modalFeedbackPulseTeaser: {
      title: 'Neugierig, wie Ihre Kandidaten das Auswahlverfahren bewerten?',
      content: 'Am Ende jedes Auswahlverfahrens können die Kandidaten ihre Erfahrung bewerten. Ihre Gesamtbewertung basiert auf dem Durchschnitt aller gesammelten Rückmeldungen.',
      cancel: 'Abbrechen',
      confirm: 'Ja, kontaktieren Sie mich',
      greetings: 'Nachricht erfolgreich gesendet.',
    },

    modalCandidateMessage: {
      title: count => (count > 1 ? 'Nachricht an ausgewählte Kandidaten senden' : 'Nachricht an Kandidaten senden'),
      description: 'Welche Art von Nachricht möchtest Du senden?',
      recipients: count => `Nachricht wird an ${count} Empfänger verschickt`,
      email: 'E-Mail senden',
      videoMessage: 'Video-Nachricht senden',
      library: 'Aus Bibliothek auswählen',
      close: 'Schließen',
      cancel: 'Abbrechen',
      continue: 'Fortfahren',
      sendEmail: 'Nachricht senden',
      resendInvitation: 'Einladung erneut versenden',
      resendInvitationSms: 'Einladung per SMS erneut versenden',
      sms: 'SMS-Nachricht senden',
      emailTitle: count => (count > 1 ? 'E-Mail an Kandidaten senden' : 'E-Mail an Kandidaten senden'),
      emailDescription: 'E-Mail an ausgewählte Kandidaten senden',
      libraryTitle: count => (count > 1 ? 'Video an Kandidaten senden' : 'Video an Kandidaten senden'),
      videoTitle: 'Neues Video hinzufügen',
      titlePlaceholder: 'Titel',
      contentPlaceholder: 'Verfasse hier Deine Nachricht',
      candidates: 'Kandidaten',
      selectedCandidates: 'Empfänger',
      emailSent: candidates => `${candidates} E-Mails gesendet!`,
      answerable: 'Video kann beantwortet werden',
      successMessage: candidates => `${candidates} Video-Nachrichten gesendet!`,
      scheduledInterview: 'Einladung zum geplanten Gespräch senden',
      scheduledInterviewDescription: 'Lassen Sie den Kandidaten ein Gespräch mit Ihnen entsprechend Ihrer angegebenen Verfügbarkeit vereinbaren.',
      reScheduledInterview: 'Termin verschieben',
      reScheduledInterviewDescription: 'Verschieben Sie ein Gespräch mit einem Kandidaten. Bitte beachten Sie, dass frühere Einladungen dann abgesagt werden.',
      record: 'Aufnehmen',
      upload: 'Hochladen',
      required: 'Mit einem * Stern gekennzeichnete Felder sind Pflichtfelder.',
      tooManyRecipients: count => `Zu viele Empfänger ausgewählt. Das Maximum ist ${count}.`,
      tooLongMessage:
        'Die Nachricht ist zu lang. Überprüfen Sie den Zeichenzähler. Anmerkung: Einige Sonderzeichen reduzieren die maximale Nachrichtenlänge.',
    },

    modalEditIntroduceBatches: {
      title: 'Kandidatenvorstellungen',
      description: 'Hier können Sie die Kandidatenvorstellungen für Ihre Stelle verwalten. Sie können das Ablaufdatum des Vorstellungslinks für den Empfänger verlängern, Empfänger aus der Vorstellungsgruppe entfernen oder komplette Vorstellungsgruppen für eine Stelle löschen.',
      noBatches: 'Keine Kandidatenvorstellungen.',
      descriptionWithCount: (candidatesCount, candidateNames) => `${candidateNames} und ${candidatesCount} weitere Kandidaten wurden folgenden Empfängern vorgestellt:`,
      descriptionWithoutCount: candidateNames => `${candidateNames} wurden folgenden Empfängern vorgestellt:`,
      expires: 'Läuft ab',
      actions: 'Aktionen',
      email: 'Email',
      close: 'Schließen',
      visited: 'Bereits besucht',
      extendLinkText: 'Verlängern',
      extendTo: date => `Bis ${date} verlängern`,
      deleteBatch: 'Vorstellungsgruppe löschen',
      deleteBatchWarning: 'Sind Sie sicher, dass Sie die Vorstellungsgruppe löschen wollen?',
      maxExpirationDate: 'Das Ablaufdatum darf maximal 10 Tage in der Zukunft liegen.',
      extendedMessage: newExpirationDate => `Das Ablaufdatum des Vorstellungslinks wurde bis zum ${newExpirationDate} verlängert!`,
      url: 'URL',
      introductionLink: 'Link',
    },

    modalEditEmailSettings: {
      customReplyToTitle: 'Informationen zum Absender der Einladungsnachricht',
      customReplyToSubtitle:
        'Hier können Sie den Absendernamen und die Antwortadresse für die Interview-Einladungen bearbeiten. Bleibt dieses Feld leer, werden der Name und die E-Mail-Adresse des Benutzers verwendet, der die Einladungen verschickt.',
      customReplyToEmail: 'Antwort-E-Mail für Interview-Einladungen',
      customReplyToName: 'Absendername für Interview-Einladungen',
      saveSuccess: 'Einstellungen erfolgreich gespeichert!',
    },

    modalEditInvitationMessage: {
      saveTemplate: 'Als Einladungsnachricht für dieses Interview speichern',
      title: 'Einladungsnachricht für das Interview bearbeiten',
      info: 'Wählen Sie das zu bearbeitende Interview aus',
      close: 'Schließen',
      templateSaved: 'Die Nachricht wurde als Vorlage für dieses Interview gespeichert.',
      templateOptionsLabel: 'Select template',
    },

    modalEditStages: {
      title: 'Einstellungsphasen bearbeiten',
      info: 'Sie können benutzerdefinierte Phasen bearbeiten, hinzufügen, löschen und neu anordnen. Eine Phase mit Kandidaten kann jedoch nicht gelöscht werden.',
      addNewStage: 'Benutzerdefinierte Phase hinzufügen',
      removeDisabled: 'Eine Phase mit Kandidaten kann nicht gelöscht werden.',
      error: 'Phase ist bereits vorhanden.',
      done: 'Fertig',
      save: 'Speichern',
      close: 'Schließen',
      confirm: 'Bestätigen',
      cancel: 'Abbrechen',
      delete: 'Löschen',
    },

    modalHidePositionsFromUser: {
      modalHeader: 'Ausgeblendete Stellen',
      modalDescription: name => `Festlegen, welche Stellen der Benutzer ${name} ansehen kann.`,
      hiddenFrom: name => `Stellen, die für den Benutzer ${name} ausgeblendet sind`,
      noResults: 'Keine Ergebnisse',
      jobAdLabel: 'Stellenanzeige',
      interviewLabel: 'Videointerview',
      noPositions: 'Keine Stellen vorhanden',
      remove: 'Entfernen',
      hide: 'Ausblenden',
      close: 'Schließen',
      searchInfo: 'Nach auszublendenden Stellen suchen',
      searchPlaceholder: 'Nach Jobtitel oder Arbeitsort suchen',
      total: total => `Insgesamt ${total} Stellen`,
      labels: {
        title: 'Titel',
        location: 'Ort',
        time: 'Erstellungsdatum',
        actions: 'Aktionen',
      },
    },

    modalRemoveUserFromOrganisation: {
      modalHeader: 'Benutzer aus dieser Organisation entfernen',
      modalDescription: name =>
        `Der Benutzer ${name} ist ein externer Benutzer und wird nur aus dieser Organisation entfernt. Nach dem Entfernen hat der Benutzer weiterhin Zugang zu anderen Organisationen innerhalb von Recright.`,
      modalExplanation: name =>
        `Folglich hat der Benutzer keinen Zugang mehr zu Stellen innerhalb dieser Organisation. Sie erben den Zugang zu den Stellen, für die ${name} der einzige Rekrutierer war.`,
      adminInRecruitmentTeam: name =>
        `Positionen, für die der Benutzer ${name} Teil des Rekrutierungsteams war:`,
      noResults: 'Keine Ergebnisse',
      noPositions: 'Keine Stellen vorhanden',
      jobAdLabel: 'Stellenanzeige',
      interviewLabel: 'Videointerview',
      total: total => `Insgesamt ${total} Stellen`,
      close: 'Schließen',
      remove: 'Aus der Organisation entfernen',
      removeUserConfirmMessage: 'Benutzer entfernen',
      removeUserConfirmContent:
        'Sind Sie sicher, dass Sie den Benutzer aus dieser Organisation entfernen möchten?',
      labels: {
        title: 'Titel',
        time: 'Erstellungsdatum',
        creator: 'Neuer Stelleninhaber',
      },
      otherAdmin: 'Anderer Administrator im Rekrutierungsteam',
    },

    modalPersonStage: {
      new: 'Neu',
      hired: 'Eingestellt',
      proceed: 'Fortfahren',
      personalinterview: 'Persönliches Interview',
      withdrawn: 'Zurückgezogen',
      scheduledinterview: 'Geplantes Vorstellungsgespräch',
      rejected: 'Abgelehnt',
      videointerviewed: 'Video-Interview',
      change: 'Kandidat(en) in andere Phase verschieben',
      info: 'Verschieben Sie den/die ausgewählten Kandidaten in eine andere Phase. Dies wird Kandidaten nicht angezeigt.',
      changedInfo: stage => `Nachdem Sie diese Kandidaten nun in die Phase „${stage}“ verschoben haben, können Sie sie per E-Mail oder Videobotschaft darüber informieren.`,
      done: 'Verschieben',
      cancel: 'Abbrechen',
      changed: 'Super!',
      close: 'Schließen',
      reopenProcessConfirmPlural: 'Sind Sie sicher, dass Sie diese Kandidaten aus der Phase "Zurückgezogen" herausnehmen und wieder in den Einstellungsprozess aufnehmen wollen? Nach der Bestätigung können die Kandidaten wieder auf ein noch nicht abgeschlossenes Interview antworten.',
      withdrawConfirmPlural: 'Sind Sie sicher, dass Sie diese Kandidaten aus dem Einstellungsprozess herausnehmen wollen? Die Kandidaten können dann keine Interviews mehr beantworten, zu denen sie eingeladen wurden.',
      changeSingle: 'Kandidaten in eine andere Phase verschieben',
      infoSingle: 'Kandidaten in eine andere Phase verschieben. Diese Information ist für den Kandidaten nicht sichtbar.',
      changedInfoSingle: stage => `Nachdem Sie den Kandidaten in die Phase „${stage}“ verschoben haben, informieren Sie ihn darüber! \n\n Senden Sie eine E-Mail oder eine Videonachricht.`,
    },

    modalInterviewAdd: {
      timedTitle: 'Zeitlich begrenztes Video-Interview',
      timedDescription: 'Die Kandidaten nehmen ihre Antworten auf die Interviewfragen in einem begrenzten und voreingestellten Zeitrahmen auf. Sie können die Zeit für die Beantwortung und Vorbereitung jeder Frage einstellen.',
      title: 'Neues Interview erstellen',
      description: 'Wählen Sie die Art des Interviews, das Sie erstellen möchten',
      friendlyTitle: 'Video-Interview',
      friendlyDescription: 'Die Kandidaten können beliebig viele Aufnahmen machen und es gibt keine zeitliche Begrenzung der Aufnahmen',
      cancel: 'Abbrechen',
      continue: 'Weiter',
    },

    modalInterviewPublish: {
      modalTitle: 'Ausschreibungs-Einstellungen',
      publicTitle: 'Öffentliches Interview',
      publicDescription: 'Dieses Interview hat eine öffentlich zugängliche Seite mit einer Adresse, die Du in Deinen Stellenangeboten und auf Deiner Firmen-Homepage teilen kannst. Jede Person, die sich für die Stelle interessiert, kann Deine Fragen sehen und dann entscheiden, ob sie teilnehmen möchte. Du erhältst die übliche Benachrichtigung, wenn die ersten Antworten eintreffen.',
      publishButton: 'Öffentlichen Link erstellen',
      unPublishButton: 'Öffentlichen Link entfernen',
      title: 'Eingebettetes Interview',
      description: 'Interview mit einer einzigen Frage, das nahtlos auf der Firmen-Homepage eingebettet werden kann. Bewerber geben ihre E-Mail-Adresse ein, nehmen eine Video-Antwort auf und geben einen Link zu ihrem LinkedIn-Profil als zusätzliche Information an (optional).',
      descriptionMultiple:
        'Integrieren Sie reibungslos ein Videointerview in Ihre Stellenausschreibung oder Ihre Firmenhomepage. Die Bewerber/innen geben einfach ihre E-Mail ein, nehmen Videoantworten auf und haben die Möglichkeit, einen Link zu ihrem LinkedIn-Profil für zusätzliche Informationen anzugeben.',
      embedNotification: 'Du kannst keine weiteren Informationen mit einer eingebetteten Frage anfordern.',
      embedButton: 'Einbettungs-Code erstellen',
      unEmbedButton: 'Einbettung entfernen',
      close: 'Schließen',
      oneError: 'Eingebettetes Interview kann nur eine Frage enthalten. Bitte entferne zusätzliche Fragen, um die Einbettungs-Funktion zu nutzen.',
      subscriptionNeeded: 'Du benötigst ein aktives Abonnement, um Dein Interview zu veröffentlichen.',
    },

    modalIntroduce: {
      title: count => (count > 1 ? 'Kandidaten vorstellen' : 'Kandidaten vorstellen'),
      descriptionFirst: 'Über die Vorstellungsfunktion können Sie ausgewählte Kandidaten einem Kollegen oder einem Kunden vorstellen.',
      descriptionSecond: 'Eine Anmeldung des Empfängers ist nicht erforderlich, um die vorgestellten Kandidaten einzusehen. Geben Sie die E-Mail-Adresse des Empfängers unten ein. Wählen Sie, welche Informationen der Empfänger über die Kandidaten einsehen kann. Der Empfänger kann nur die ausgewählten Informationen einsehen. Wenn Sie ‚Bewertung‘ oder ‚Kompetenzen und Verträglichkeit‘ auswählen, kann der Empfänger seine eigene Bewertung eingeben und die durchschnittliche Bewertung einsehen.',
      descriptionThird: 'Sie haben zudem die Option, die Kandidatenvorstellungen mit einem Zugangscode zu schützen, den der Empfänger eingeben muss, um die vorgestellten Kandidaten einzusehen.',
      descriptionFourth: days =>
        `Der Vorstellungslink läuft in ${days} Tagen ab. Sie können das Ablaufdatum in den Einstellungen für "Vorstellungen" verlängern. Klicken Sie dazu im Menü "Bearbeiten" auf "Vorstellungen bearbeiten".`,
      titlePlaceholder: 'Titel',
      contentPlaceholder: 'Inhalt der Nachricht',
      emailsPlaceholder: 'E-Mail-Adressen der Empfänger',
      namePlaceholder: 'Name',
      cancel: 'Abbrechen',
      sendIntroductions: 'Vorstellungen senden',
      selectedCandidates: count => `${count} kandidaten zur Vorstellung ausgewählt`,
      successMessage: (candidates, introducees) => `${candidates} Kandidaten ${introducees} Zuständigen vorgestellt`,
      infoMessage: (candidates, introducees, isInTeam) => `${candidates} Kandidaten wurden ${introducees} Vorgestellten vorgestellt. ${isInTeam} waren bereits im Rekrutierungsteam.`,
      alreadyInTeam: inTeam => (inTeam > 1 ? 'sind bereits im Rekrutierungsteam.' : 'ist bereits im Rekrutierungsteam.'),
      name: 'Name',
      email: 'E-Mail',
      phone: 'Telefonnummer',
      city: 'Stadt',
      coverLetter: 'Bewerbungsschreiben',
      attachments: 'Anhänge',
      links: 'Links',
      competencies: 'Kompetenzen und Kompatibilität',
      rating: 'Bewertung',
      selectAll: 'Alle auswählen',
      resetSelection: 'Auswahl zurücksetzen',
      videoResponses: 'Videoantworten',
      comments: 'Kommentare',
      informationsHeader: 'Wählen Sie, welche Informationen eingesehen werden können',
      messageHeader: 'Begrüßung',
      usePasscodeText: 'Vorstellungsgruppe mit einem Zugangscode schützen',
      passcode: 'Zugangscode',
      copyToClipboard: 'Code in die Zwischenablage kopieren',
      generatePasscode: 'Neuen Zugangscode generieren',
      copySuccess: 'Der Zugangscode wurde kopiert!',
      close: 'Close',
      introduceLinkButton: 'Create link',
      introduceLink: 'Introduce link',
      introduce: 'Introduce',
      formError: 'Error',
      linkCreationError: 'Error creating introduction link',
      link: 'Link',
      continue: 'Fortfahren',
    },

    modalInterviewInvite: {
      senderInfo: 'Einladungen werden von der E-Mail-Adresse invitations@recright.com gesendet.',
      replyToEmail: 'Antwort-E-Mail für Interview-Einladungen',
      replyToName: 'Absendername für Interview-Einladungen',
      replyToInfo:
        'Sie können diese Felder auf der Seite zur Bearbeitung von Interviews bearbeiten.',
      notAnswerable: 'Du kannst keine Benutzer zu einem geschlossenen Interview oder eine Interview einladen, das keine zu beantwortenden Fragen enthält.',
      title: 'Kandidaten einladen',
      description: 'Gib die E-Mail-Adressen aller Kandidaten ein. Wenn sie antworten, wirst Du per E-Mail benachrichtigt.',
      description2: 'Beachte, dass Du keine weiteren Fragen hinzufügen kannst, nachdem Du Kandidaten eingeladen hast.',
      smsDescription: 'Wenn Sie E-Mail-Einladungen verschickt haben, können Sie eine SMS-Nachricht an die Kandidaten senden',
      addressesPlaceholder: 'E-Mail-Adressen der Kandidaten',
      submit: 'Einladungen senden',
      cancel: 'Abbrechen',
      close: 'Schließen',
      templateChangedInfo: 'Sie haben die Einladungsnachricht bearbeitet. Die geänderte Nachricht wird an diese Gruppe von Empfängern gesendet, aber nicht im Interview gespeichert.',
      inviteInfo: (newInvitees, stage) => `Die Einladungsnachricht wird an ${newInvitees} der ausgewählten Kandidaten gesendet. Alle ausgewählten Kandidaten werden in die Phase "${stage}" verschoben.`,
      templateSaved: 'Die Nachricht wurde als Vorlage für das Interview gespeichert.',
      invitesSent: (success, failed) => (failed > 0 ? `${success} Einladungen gesendet und ${failed} wurde bereits eingeladen.` : `${success} Einladungen gesendet.`),
      subscriptionNeeded: 'Sie benötigen ein aktives Abonnement, um Kandidaten einzuladen.',
      saveTemplate: 'Als Einladungsnachricht für dieses Interview speichern',
      rrTemplateOptionLabel: 'Recright Standardvorlage',
      interviewTemplateOptionLabel: 'Einladungsnachricht für dieses Interview gespeichert',
      templateOptionsLabel: 'Vorlage auswählen',
    },

    modalInterviewInviteSms: {
      title: 'Einladungen erfolgreich gesendet',
      description: count => `${count} erfolgreich gesendete Einladungen`,
      description2: 'Möchten Sie auch eine SMS-Nachricht an die eingeladenen Kandidaten senden?',
    },

    modalSmsMessage: {
      title: 'SMS-Nachricht senden',
      description: count => `Nachricht wird an ${count} Empfänger verschickt`,
      invitationTitle: 'Einladung per SMS senden',
      resendInvitationTitle: 'Einladung per SMS erneut versenden',
      missingInvitationDescription: count => `${count} Empfänger haben keine Einladung erhalten. Bitte schreiben Sie die untenstehende Einladungsnachricht.`,
      missingPhone: count => `Bei ${count} Empfängern fehlt eine gültige Mobiltelefonnummer.`,
      missingPhone2: 'Bitte tragen Sie die Mobiltelefonnummern in die untenstehenden Felder ein.',
      successMessage: count => `${count} SMS-Nachrichten erfolgreich gesendet`,
      partialSuccessMessage: (successCount, failedCount) => `${successCount} SMS-Nachrichten erfolgreich gesendet. ${failedCount} SMS-Nachrichten wurden nicht zugestellt.`,
      failedMessage: 'SMS-Nachrichten an die Empfänger wurden nicht zugestellt.',
      phonePlaceholder: 'Telefonnummer',
      recipientsNotFound: 'Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es später erneut. Wenn das Problem weiterhin besteht, wenden Sie sich bitte an unseren Support.',
    },

    modalInterviewStatus: {
      change: 'Interview-Status ändern',
      changed: 'Interview-Status geändert',
      changedInfo: 'Interview-Status geändert. Denke daran, die Kandidaten über Entscheidungen zu informieren!',
      info: 'Wähle den neuen Status für das Interview.',
      open: 'Offen',
      closed: 'Geschlossen',
      done: 'Fertig',
      close: 'Schließen',
      endTimeInPast: 'Das Enddatum des Interviews liegt in der Vergangenheit. Wenn Sie das Interview öffnen, wird das Enddatum entfernt. Sie können ein neues Enddatum festlegen unter ',
      endTimeInPastLink: 'Seite bearbeiten',
      cancel: 'Abbrechen',
    },

    modalInterviewSelectForEdit: {
      title: 'Interview bearbeiten',
      info: 'Wählen Sie das zu bearbeitende Interview aus.',
      cancel: 'Abbrechen',
      done: 'Fertig',
      error: {
        selectInterview: 'Bitte wähle ein Interview.',
      },
    },

    modalInterviewTeaser: {
      title: 'Triff mit Video-Interviews die richtige Entscheidung',
      content1: 'Das Video-Interview ist ein natürlicher nächster Schritt, nachdem Du Bewerbungen von Kandidaten erhalten hast.',
      upgradeTitle: 'Upgrade 295 EUR/Monat',
      upgradeDescription: 'Nimm ein Upgrade Deines Plans vor, um 15 Video-Interview-Positionen pro Jahr zu erhalten. Dein aktueller Tarif wird durch diesen ersetzt.',
      singleHireTitle: price => `Einzelne Einstellung ${price} EUR/Interview`,
      singleHireDescription: 'Nutze ein Video-Interview für eine Stelle in 60 Tagen. Du kannst mehrere Kandidaten einladen.',
      tryTitle: 'Kostenlos testen',
      tryDescription: 'Erstelle ein Video-Interview und zeichne Video-Fragen auf. Du musst ein Upgrade Deines Tarifs vornehmen oder "Einzelne Einstellung" erwerben, bevor Du Kandidaten einladen kannst.',
      contactTitle: 'Kontakt',
      contactDescription: 'Sende uns eine Kontaktanfrage. Wir melden uns im Laufe des nächsten Wochentags!',
      cancel: 'Abbrechen',
      confirm: 'Fortfahren',
      greetings: 'Nachricht erfolgreich gesendet.',
      confirmTitle: 'Kauf bestätigen',
      confirmDescription: 'Video-Interview ist nur einen Klick entfernt. Bestätige nur noch die Zahlung, und schon kannst Du loslegen!',
    },

    modalJobAdPreview: {
      title: 'Vorschau der Stellenanzeige',
      description: 'Hier sehen Sie, wie die Stellenanzeige für den Kandidaten aussieht.',
      description2: 'Beachten Sie, dass die in der Vorschau verwendete Sprache nicht der für die Stellenanzeige festgelegten Sprache entspricht.',
      close: 'Schließen',
      back: 'Zurück',
    },

    modalJobAdStatus: {
      change: 'Stellen-Status ändern',
      changed: 'Stellen-Status geändert',
      changedInfo: 'Stellen-Status geändert. Denke daran, die Kandidaten über Entscheidungen zu informieren!',
      info: 'Wähle den neuen Status für die Stelle. Wenn Du den Status auf "Besetzt" oder "Abgebrochen" setzt, wirst Du durch die erforderlichen Schritte für die Auswahl der eingestellten Personen und/oder zum Senden der verbleibenden "Nein, danke"-Nachrichten geführt',
      open: 'Offen',
      filled: 'Besetzt',
      cancelled: 'Abgebrochen',
      done: 'Fertig',
      close: 'Schließen',
      draft: 'Geschlossen (Entwurf)',
      closed: 'Geschlossen',
      unpublished: 'Unveröffentlicht',
      hidden: 'Verborgen',
      openDescription: 'Stelle ist ausgeschrieben bis',
      filledDescription: 'Die Stellenanzeige schließen, weil die Stelle besetzt wurde',
      cancelledDescription: 'Die Stellenanzeige schließen, weil das Einstellungsverfahren abgebrochen wurde',
      closedDescription: 'Stellenanzeige ist geschlossen. Die Stellenanzeige ist für die Kandidaten nicht zugänglich oder sichtbar.',
      hiddenDescription: 'Die Stelle auf der Karriereseite verbergen. Stelle ist nur mit direktem Link zugänglich:',
      unpublishedDescription: 'Stellenanzeige ist nicht veröffentlicht. Die Stellenanzeige ist für die Kandidaten nicht zugänglich oder sichtbar.',
      cancel: 'Abbrechen',
    },

    modalJobPositionTeam: {
      addAnother: 'Fügen Sie weitere Benutzer hinzu, indem Sie ihre E-Mail-Adressen angeben',
      team: 'Einstellungsteam',
      info: 'Du kannst Kollegen oder sonstige Personen zur Überprüfung und Bewertung von Kandidaten hinzufügen',
      newMembersMsg: 'Neue Teammitglieder ohne bestehendes Konto in Recright werden zu der Organisation hinzugefügt, zu der diese Position gehört.* Wenn die E-Mail-Domäne des Benutzers nicht mit der Domäne übereinstimmt, die mit der Organisation verknüpft ist, erhält der Benutzer nur minimale Benutzerberechtigungen. Die Benutzerrechte können nachträglich von Administratoren geändert werden, die Zugriff auf die Benutzerverwaltung haben.',
      asteriskSymbol: '*',
      currentTeam: 'Aktuelles Team',
      done: 'Fertig',
      remove: 'Entfernen',
      submit: 'Teammitglieder hinzufügen',
      cancel: 'Abbrechen',
      selfRemovedMessage: 'Sie haben sich aus dem Rekrutierungsteam entfernt.',
      successMessage: count => `Es wurden ${count} Mitglieder zum Rekrutierungsteam hinzugefügt.`,
      errors: {
        duplicate: 'E-Mail-Adresse wurde bereits hinzugefügt.',
        duplicateMultiple: 'Teammitglied(er), die bereits mit einer oder mehreren hinzugefügten E-Mails gefunden wurden.',
        isEmail: 'E-Mail ist ungültig.',
        isEmailMultiple: 'Ungültige E-Mails gefunden',
        isRequired: 'Feld ist erforderlich.',
      },
    },

    modalJobPositionCopy: {
      title: (context, position) => `Möchtest Du wirklich eine Kopie des ${context === 'jobAd' ? 'Stellenangebots' : 'Interviews'} "${position.title}" erstellen?`,
      admins: 'Möchtest Du auch das Einstellungsteam kopieren?',
      done: 'Kopieren',
      cancel: 'Abbrechen',
    },

    modalVideos: {
      title: 'Video-Bibliothek',
      yourVideos: 'Ihre Videos',
      companyVideos: 'Unternehmensvideos',
      sort: {
        createdAt: 'Erstellungsdatum',
        title: 'Titel',
      },
      add: 'Hinzufügen',
      done: 'Videos hinzufügen',
      cancel: 'Abbrechen',
    },

    modalUsersAdd: {
      title: 'Benutzer einladen',
      languageDescription: 'Diese Benutzer werden folgende Sprache haben:',
      permissionsDescription: 'Diese Benutzer werden folgende Berechtigungen haben:',
      emailsPlaceholder: 'E-Mail-Adressen des Benutzers eingeben',
      seeAllPositions: 'Alle Stellen ansehen',
      createJobPositions: 'Arbeitsstelle erstellen',
      createInterviews: 'Interviews erstellen',
      account: 'Informationen zum Unternehmen bearbeiten',
      billing: 'Abrechnung',
      reporting: 'Berichtswesen',
      editUsers: 'Benutzer bearbeiten',
      default: 'Standardberechtigungen des Unternehmens',
      cancel: 'Abbrechen',
      submit: 'Benutzer einladen',
    },

    modalCompanyDefaultPermissionsEdit: {
      title: 'Standardberechtigungen des Unternehmens:',
      description: 'Alle neuen Benutzer, die sich für dieses Unternehmen anmelden, erhalten automatisch die Standardberechtigungen.',
      seeAllPositions: 'Alle Stellen ansehen',
      createJobPositions: 'Arbeitsstelle erstellen',
      createInterviews: 'Interviews erstellen',
      account: 'Informationen zum Unternehmen bearbeiten',
      billing: 'Abrechnung',
      reporting: 'Berichtswesen',
      editUsers: 'Benutzer bearbeiten',
      cancel: 'Bearbeiten',
      submit: 'Speichern',
    },

    modalOtherApplications: {
      title: 'Kandidat in anderen Positionen',
      header: 'Hier ist eine Liste des gleichen Kandidaten in anderen Positionen',
      close: 'Schließen',
    },

    getPermissionsLabels: {
      permissions: {
        seeAllPositions: 'Alle Stellen ansehen',
        createJobPositions: 'Arbeitsstelle erstellen',
        createInterviews: 'Interviews erstellen',
        account: 'Informationen zum Unternehmen bearbeiten',
        billing: 'Abrechnung',
        reporting: 'Berichtswesen',
        editUsers: 'Benutzer bearbeiten',
        default: 'Standardberechtigungen',
      },
    },

    // TODO: Translations missing!
    modalCronofy: {
      linkCalendar: {
        title: 'Link your calendar to Recright',
        description: 'Use our partner Cronofy to link your calendar to Recright',
        authorize: 'Authorize your calendar here',
        authorized: profileName => `You have successfully linked calendar ${profileName} to your Recright account`,
        revokeAuthorization: 'Unlink the calendar from Recright',
      },
      personalInterview: {
        title: 'Create the invitation for scheduled interview',
        description: 'If you’d like to meet the candidate in person, you may invite them to self-schedule a meeting. First, choose the interviewers for the meeting, then set your availability by choosing the dates, times as well as the length of the slots. Add in a message to personalize your invitation. \n\nThe candidate will receive an email to book the meeting. When the candidate chooses a time slot, the interviewers will get an email confirmation with the candidate’s details, and the meeting will appear on the calendar.',
        interviewersHeader: 'Select interviewers',
        noInterviewersSelected: 'Select at least one interviewer with linked calendar to continue',
        otherInterviewersHeader: 'Other interviewers',
        removeOtherInterviewers: 'Remove',
        deselectAll: 'Deselect all',
        selectAll: 'Select all',
        interviewerCalendarNotConnectedNote: 'The user\'s calendar is not linked to Recright. Scheduling information email will still be sent to the user\'s email.',
        singleInterviewer: 'Interviewer',
        allInterviewersCalendarNotConnected: 'None of the interviewers have their calendar connected to Recright',
        addMoreInterviewersToTeam: 'Click here to add more interviewers to the team',
        userCalendarNotConnected: 'You don\'t have your calendar connected to Recright',
        userConnectCalendar: 'Connect your calendar here',
        addNewInterviewer: 'Add new interviewer\'s email address',
        timeSlot: {
          description: 'Choose the timeframe and interview length for the interview.\nAfter that you see what slots are available for candidate to choose from.',
          startDate: 'Timeframe start date',
          endDate: 'Timeframe end date',
          endDatePlaceholder: 'End date',
          startDatePlaceholder: 'Start date',
          endDateWarning: 'Select the time frame end date for the scheduled meetings',
          startTime: 'Start time for the day',
          endTime: 'End time for the day',
          timezone: 'Time zone',
          timezoneHelp: 'Please note that changing the timezone also adjusts date and time accordingly.',
        },
        useAllTimeSlots: 'Let candidate choose from all available time slots in the chosen timeframe',
        noTimeSlotsSelected: 'Select at least one timeslot from the Availability below\nor let the candidate choose from all available time slots',
        slotPickerDescription: 'See what slots are available for candidate to choose from.',
        showAvailability: 'Show availability',
        refreshAvailability: 'Refresh availability',
        slotLength: 'Slot length',
        availabilityError: 'Unable to show availability. Please try again later and if the problem persists please contact our support.',
        recipients: count => `Message will be sent to ${count} candidates`,
        confirmRescheduleMessage: 'Termin verschieben',
        confirmRescheduleContent: 'Einige Empfänger haben bereits einen Termin. Möchten Sie neue Einladungen versenden? So wird der bereits geplante Termin gelöscht.',
      },
      personalInterviewMessage: {
        title: 'Create message for calendar invitation',
        successTitle: 'Great',
        successDescription: candidateLength => `You invited ${candidateLength} people to personal interview. They have also been moved to stage 'Personal Interview'`,
        message: {
          emailMessage: 'Email message',
          title: title => `Let’s have a meeting regarding ${title}`,
          content: title => `Hey! We were impressed with your application for ${title} position and would like to invite you for a meeting and tell you a little more about the position and get to know you better.\n\nPlease let me know which of the following times best for you by clicking this scheduling link.\n\nLooking forward to meeting you!`,
          event: {
            header: 'Calendar event information',
            description: 'Insert here information that is included in the calendar event',
            titlePlaceholder: 'Event title',
            locationPlaceholder: 'Event location',
          },
        },
        close: 'Close',
        saveDefaultLocation: 'Save location as default location',
        savedDefaultLocation: 'Saved as default location',
        invitationError: 'We were unable to send calendar invitation. Please try again later and if the problem persists please contact our support.',
      },
    },

    // TODO: Translations missing!
    modalVideoEdit: {
      save: 'Speichern',
      cancel: 'Abbrechen',
      addTag: 'Tag hinzufügen',
      title: 'Video bearbeiten',
      success: 'Änderungen am Video wurden erfolgreich gespeichert!',
      error:
        'Wir waren nicht in der Lage, die Änderungen zu speichern. Bitte versuchen Sie es später erneut. Wenn das Problem weiterhin besteht, wenden Sie sich bitte an unseren Support.',
    },

    noResults: {
      description: 'Ihre Liste scheint leer zu sein. Wenn Sie die Liste gefiltert haben, entfernen Sie ein paar Filter.',
    },

    notifications: {
      notifications: 'Benachrichtigungen',
    },

    notificationsSubscribeButton: {
      subscribe: 'Abonnieren',
      subscribed: 'Abonniert',
      unsubscribe: 'Abbestellen',
    },

    onboardTutorial: {
      ui: {
        back: 'Zurück',
        close: 'Schließen',
        last: 'Letzte',
        next: 'Weiter',
        skip: 'Deaktivieren',
      },
      dashboard: [
        {
          title: 'Welcome to Recright!',
          text: 'First thing first. Let\'s connect your calendar, so you can schedule meetings with candidates! <a href="/admin/account">Connect your calendar here!</a>',
          selector: '.joyride--welcome-calendar',
          position: 'top',
          style: {
            beacon: {
              offsetY: -625,
            },
          },
        },
        {
          title: 'Willkommen zu Recright!',
          text: 'Wir werden Dich mit interaktiven Leitfäden durch das Tool führen. Du kannst den Hilfetext für jede Funktion durch Klicken auf den Impuls anzeigen lassen. Leitfäden können jederzeit erneut sichtbar gemacht werden, indem Du auf Deinen Namen und dann auf "Tutorial anzeigen" klickst.',
          selector: '.joyride--welcome',
          position: 'top',
          style: {
            beacon: {
              offsetY: -625,
            },
          },
        },
        {
          title: 'Neues Stellenangebot erstellen',
          text: 'Hier kannst Du ein neues Stellenangebot erstellen und veröffentlichen und Bewerbungen empfangen.',
          selector: '.joyride--add-job-ad',
          position: 'bottom-left',
        },
        {
          title: 'Neues Video-Interview erstellen',
          text: 'Hier kannst Du ein neues Video-Interview erstellen und Kandidaten einladen.',
          selector: '.joyride--add-videointerview',
          position: 'bottom-left',
        },
        {
          title: 'Einstellungen',
          text: 'Hier kannst Du Deine Kontoeinstellungen ändern, das Aussehen und die URL Deiner Karriereseite auswählen, Deine Video-Bibliothek verwalten sowie Deine bevorzugte Sprache auswählen. Du kannst außerdem diesen Impuls-Leitfaden aktivieren, indem Du auf "Tutorial anzeigen" klickst.',
          selector: '.joyride--profile-settings',
          position: 'bottom-left',
        },
      ],
      // TODO: Translations missing!
      accountDetails: [
        {
          title: 'Connect your calendar here!',
          text: 'Come on! Do it! Do it now! What are you waiting for?! Do it now!',
          selector: '.joyride--connect-calendar',
          position: 'top',
        },
      ],
      jobAdEdit: [
        {
          title: 'Kopfbanner und Logo hinzufügen',
          text: 'Du kannst ein Kopfbanner zu der Stelle hinzufügen, das für Deine Kandidaten sichtbar ist. Die optimale Bildgröße beträgt 1440 x 320 Pixel. Vergiss nicht, auch Dein Logo hinzuzufügen.',
          selector: '.joyride--job-ad-images',
          position: 'top',
        },
        {
          title: 'Titel, Standort, Veröffentlichungsdaten',
          text: 'Gib die Stellenbezeichnung und den Standort ein und lege das Veröffentlichungsdatum und den Bewerbungsschluss fest. Falls "Offen bis" leer bleibt, ist die Stelle bis auf Weiteres offen.',
          selector: '.joyride--job-ad-title',
          position: 'top',
        },
        {
          title: 'Job-Beschreibung',
          text: 'Gib oder füge Deine Stellenbeschreibung hier ein. Denke daran, mindestens zu erwähnen, wonach Du suchst, was die Voraussetzungen sind und was Du zu bieten hast.',
          selector: '.joyride--job-ad-description',
          position: 'top',
        },
        {
          title: 'Arbeitgeber-Video',
          text: 'Du kannst Deine Unternehmenskultur fördern und das Arbeitgeber-Branding stärken, indem Du ein Arbeitgebervideo zur Stellenanzeige hinzufügst.',
          selector: '.joyride--job-ad-employer-video',
          position: 'top',
        },
        {
          title: 'Bewerbungsformular-Erstellung',
          text: 'Wähle aus, welche Informationen Du über Deine Kandidaten erhalten möchtest. Die zu beantwortenden Felder können entweder optional oder Pflichtfelder sein.',
          selector: '.joyride--job-ad-application-setup',
          position: 'top',
        },
        {
          title: 'Video-Frage',
          text: 'Du kannst Deinen Kandidaten bereits in der Bewerbungsphase eine spezifische Video-Frage stellen und die Bewerbungen mithilfe von Video-Antworten zum Leben erwecken. Dies ist außerdem eine hervorragende Gelegenheit, Deine Kandidaten zu begrüßen.',
          selector: '.joyride--job-ad-video-questions',
          position: 'right',
        },
      ],
      interviewEdit: [
        {
          title: 'Kopfbanner und Logo hinzufügen',
          text: 'Du kannst ein Kopfbanner zum Interview hinzufügen, das für Deine Kandidaten sichtbar ist. Die optimale Bildgröße beträgt 1440 x 320 Pixel. Vergiss nicht, auch Dein Logo hinzuzufügen.',
          selector: '.joyride--interview-images',
          position: 'top',
        },
        {
          title: 'Titel, offen bis',
          text: 'Gib den Titel für Dein Video-Interview ein und lege die Frist zum Beantworten fest. Falls Du "Offen bis" leer lässt, ist das Interview bis auf Weiteres offen.',
          selector: '.joyride--interview-title',
          position: 'top',
        },
        {
          title: 'Bewerbungsformular-Erstellung',
          text: 'Wähle aus, welche Informationen Du über Deine Kandidaten erhalten möchtest. Die zu beantwortenden Felder können entweder optional oder Pflichtfelder sein.',
          selector: '.joyride--interview-form-setup',
          position: 'top',
        },
        {
          title: 'Interview-Fragen',
          text: 'Zeichne Deine Video-Fragen auf oder lade sie hoch. Du kannst Video-Fragen in der Bibliothek speichern, nachdem Du sie hinzugefügt hast, und sie später erneut verwenden. Du kannst außerdem Textfragen verwenden, falls Du nicht die Möglichkeit hast, Video-Fragen zu nutzen. Kandidaten antworten immer per Video.',
          selector: '.joyride--interview-video-questions',
          position: 'bottom-right',
        },
      ],
      createdJobAd: [
        {
          title: 'Aktionen für Stellenangebot',
          text: 'Hier können Sie die Stellenanzeige bearbeiten, ihren Status ändern und Ihr Team zur Beurteilung der Kandidaten einladen.',
          selector: '.joyride--created-actions-left',
          position: 'top',
        },
        {
          title: ' Die Verbreitung einer Stellenanzeige',
          text: 'Verbreiten Sie Ihre Stellenanzeige, indem Sie diese in Ihren Social-Media-Kanälen teilen.',
          selector: '.joyride--created-actions-right',
          position: 'top',
        },
      ],
      createdInterview: [
        {
          title: 'Aktionen für Video-Interview',
          text: 'Hier können Sie das Videointerview bearbeiten, seinen Status ändern und Ihr Team zur Beurteilung der Kandidaten einladen.',
          selector: '.joyride--created-actions-left',
          position: 'top',
        },
        {
          title: 'Einladungs- und Veröffentlichungseinstellungen',
          text: 'Laden Sie Kandidaten ein oder veröffentlichen Sie Ihr Videointerview. Verbreiten Sie dieses und teilen Sie es in Ihren Social-Media-Kanälen.',
          selector: '.joyride--created-actions-right',
          position: 'top',
        },
      ],
      ApplicationView: [
        {
          title: 'Kommentare und Klassifizierungen',
          text: 'Du kannst die Kandidaten kommentieren, sie mit Tags klassifizieren und mit Sternen bewerten. Denke daran, einen geeigneten Status für die Kandidaten festzulegen, sodass Dein Team über Deine Entscheidung informiert ist. Kandidaten sehen diese Informationen nicht.',
          selector: '.joyride--comments',
          position: 'top',
        },
      ],
    },

    organisationSubMenu: {
      index: 'Organisationsprofil',
      branding: 'Branding',
      stages: 'Phasen',
      emailTemplates: 'E-Mail-Vorlagen',
      competencies: 'Kompetenzen',
    },

    passcode: {
      passcode: 'Zugangscode',
      showPasscode: 'Zugangscode anzeigen',
      hidePasscode: 'Zugangscode ausblenden',
    },

    passwordIndicator: {
      errors: [
        'Das Passwort muss mindestens 12 Zeichen enthalten.',
        'Das Passwort muss weniger als 128 Zeichen enthalten.',
        'Das Passwort darf keine Folge von drei oder mehr sich wiederholenden Zeichen enthalten.',
        'Das Passwort sollte mindestens einen Kleinbuchstaben enthalten: a-z',
        'Das Passwort sollte mindestens einen Großbuchstaben enthalten: A-Z',
        'Das Passwort sollte mindestens eine Zahl enthalten: 0-9',
        'Das Passwort sollte mindestens ein Sonderzeichen enthalten: (z.B. !, #, &)',
      ],
      strengthLabel: 'Passwortstärke: ',
      strengthValue: {
        insufficient: 'Unzureichend',
        weak: 'Schwach',
        medium: 'Mittel',
        strong: 'Stark',
      },
      learnMore: 'Lernen Sie, wie man ein starkes Passwort erstellt',
    },

    personDetails: {
      namePlaceholder: 'Kandidat',
      links: 'Links',
      attachments: 'Anhänge',
      coverLetter: 'Anschreiben',
      referrer: 'Ursprung',
      referrerInfo: 'Die Webseite, von der der Kandidat zu dem Service kam.',
      headerAdditionalInformation: 'Zusätzliche Informationen',
      lastSeen: time => `Zuletzt gesehen ${time}.`,
      otherPersons: count => `Also gefunden auf ${count} anderen Positionen`,
      state: {
        invited: 'Eingeladen',
        visited: 'Aufgerufen',
        incomplete: 'Unvollständig',
        completed: 'Abgeschlossen',
      },
      notVisited: 'Hat das Interview nicht besucht.',
      name: 'Name',
      email: 'E-Mail',
      phone: 'Telefonnummer',
      city: 'Stadt',
    },

    personEdit: {
      header: 'Angaben zum Kandidaten bearbeitens',
      description: context => `Sie können alle wichtigen Kandidateninformationen bearbeiten, die für Kandidaten auf dem ${context === 'application' ? 'Bewerbungs' : 'Interview'}formular sichtbar sind.`,
      name: 'Name des Kandidaten',
      email: 'E-Mail-Adresse des Kandidaten',
      phone: 'Telefonnummer des Kandidaten',
      city: 'Stadt des Kandidaten',
      link: 'Füge einen Link hinzu, z. B. zu Deinem LinkedIn-Profil.',
      links: 'Links hinzufügen, z. B. zum LinkedIn-Profil',
      coverLetter: 'Bewerbungsschreiben',
      attachments: 'Anhänge',
      save: 'Speichern',
      cancel: 'Abbrechen',
      editDetails: 'Angaben bearbeiten',
      editSuccess: 'Angaben zum Kandidaten wurden gespeichert!',
    },

    personRow: {
      noStage: 'Noch in keiner Phase',
      lastSeen: time => `Zuletzt gesehen ${time}.`,
      notVisited: 'Hat das Interview nicht besucht.',
      selectPerson: 'Auswählen',
      deselectPerson: 'Auswahl entfernen',
      openPersonPage: 'Offen',
      icons: {
        messages: messagesSent => `${messagesSent} Nachrichten gesendet`,
        message: messagesSent => `${messagesSent} Nachricht gesendet`,
        noMessages: 'Keine Nachrichten gesendet',
        introduction: introductions => `${introductions} Vorstellung`,
        introductions: introductions => `${introductions} Vorstellungen`,
        noIntroductions: 'Keine Vorstellungen',
        comment: comments => `${comments} Kommentar`,
        comments: comments => `${comments} Kommentare`,
        noComments: 'Keine Kommentare',
        appliedWithLinkedIn: 'Hat sich über LinkedIn beworben ',
      },
      state: {
        invited: 'Eingeladen',
        visited: 'Aufgerufen',
        incomplete: 'Unvollständig',
        completed: 'Abgeschlossen',
      },
    },

    pipeline: {
      editInterview: 'Interview bearbeiten',
      titleLabel: 'Interview-Titel',
      endTimeLabel: 'Offen bis',
      statusLabel: 'Status',
      locationLabel: 'Standort',
      editStages: 'Phasen bearbeiten',
      interviewSchedulingDescription: 'This stage contains candidates that have peen invited to a personal meeting.',
      pipelineTooltip: 'Verfolgen Sie Kandidaten während des Einstellungsprozesses und begleiten Sie sie durch die verschiedenen Phasen der Rekrutierungs-Pipeline. Sie können die Bewerbungen nach Phasen oder anderen Kriterien filtern.',
    },

    positionListing: {
      type: 'Typ',
      title: 'Bezeichnung',
      owner: 'Besitzer',
      count: 'Anzahl',
      invited: 'Eingeladen',
      visited: 'Besucht',
      answered: 'Beantwortet',
      hired: 'Eingestellt',
      leadTime: 'Vorlaufzeit',
      leadTimeValue: v => `${v} Tage`,
      created: 'Erstellungsdatum (GMT)',
      start: 'Veröffentlichungsdatum (GMT)',
      end: 'Enddatum (GMT)',
      jobAdLabel: 'Stellenanzeige',
      interviewLabel: 'Videointerview',
      timedLabel: 'Zeitlich begrenztes Video-Interview',
      embedLabel: 'Eingebettetes Interview',
      publicLabel: 'Öffentliches Interview',
      timezone: 'Timezone',
      feedback: 'Feedback-Statistik',
    },

    qrCodeDownload: {
      download: 'QR-Code herunterladen',
    },

    recentPositionsContainer: {
      createNew: 'Neu erstellen',
      showAll: 'Alle anzeigen',
    },

    recentJobAds: {
      openJobPositions: 'Stellenangebote',
      showAllJobPositions: 'Alle  Stellenangebote anzeigen',
      createNewJobPosition: 'Neues Stellenangebot erstellen',
      subscriptionNeeded: 'Du benötigst ein aktives Abonnement, um dieses Stellenangebot zu veröffentlichen.',
      confirmSingleHire: 'Eine Deiner erworbenen einzelnen Einstellungen wird für dieses Stellenangebot verwendet.',
      newApplications: 'Ungesehen',
      responses: 'Bewerbungen',
    },

    recentInterviews: {
      openVideoInterviews: 'Video-Interviews',
      showAllVideoInterviews: 'Alle Video-Interviews anzeigen',
      createNewVideoInterview: 'Neues Video-Interview erstellen',
      invites: 'Einladungen',
      responses: 'Antworten',
      timedTitle: 'Zeitlich begrenztes Video-Interview',
    },

    registrationForm: {
      email: 'Email',
      submit: 'Im Dienst anmelden',
      password: 'Kennwort',
      confirmPassword: 'Kennwort bestätigen',
      agreeTos: 'Ich habe die Nutzungsbedingungen von Recright ',
      agreeTosLinkText: 'gelesen und stimme ihnen zu.',
      privacyPolicy: 'Ich habe mich mit den Datenschutzbestimmungen ',
      privacyPolicyLinkText: 'vertraut gemacht.',
      licenseAgreement: 'Im Namen des Unternehmens, das ich vertrete, akzeptiere ich die ',
      licenseAgreementLinkText: 'Allgemeinen Geschäftsbedingungen von Recright.',
      newsletter: 'Monatlichen Newsletter abonnieren.',
      name: 'Namen',
      namePlaceholder: 'Vorname Nachname',
      organization: 'Organisation',
      companyDomain: domain => `Gestatte Benutzern die Anmeldung mit der Domain ${domain}, um diesem Unternehmen hinzugefügt zu werden.`,
      error: {
        password: {
          isRequired: 'Ein Passwort ist erforderlich. ',
          isValidPassword: 'Das Passwort muss aus mindestens 12 Zeichen bestehen und mindestens einen Groﬂbuchstaben, einen Kleinbuchstaben und eine Ziffer enthalten.',
          passwordsMatch: 'Die Passwörter stimmen nicht überein.',
        },
      },
    },

    requestCustomPlan: {
      info: 'Hast Du höhere Volument?',
      cta: 'Angebot für individuellen Tarif anfordern',
      successMessage: 'Anfrage erfolgreich gesendet.',
    },

    subscriptionNeededAlert: {
      contactPersonWithBillingPermission: 'Bitte wenden Sie sich an die für die Abrechnung zuständige Person in Ihrer Organisation.',
    },

    search: {
      placeholder: 'Zoeken',
    },

    searchFilter: {
      filter: 'Filter',
      headings: {
        location: 'Standort',
        status: 'Status',
        state: 'Fortschritt',
        tags: 'Tags',
        rating: 'Bewertung',
        stage: 'Phase',
      },
      state: {
        invited: 'Eingeladen',
        visited: 'Aufgerufen',
        incomplete: 'Unvollständig',
        completed: 'Abgeschlossen',
      },
      status: {
        open: 'Offen',
        filled: 'Besetzt',
        cancelled: 'Abgebrochen',
        draft: 'Geschlossen (Entwurf)',
        unpublished: 'Unveröffentlicht',
        hidden: 'Verborgen',
        hired: 'Eingestellt',
        proceed: 'Fortfahren',
        new: 'Neu',
        all: 'Alle',
        videointerviewed: 'Video-Interview',
        personalinterview: 'Persönliches Interview',
        withdrawn: 'Zurückgezogen',
        scheduledinterview: 'Geplantes Vorstellungsgespräch',
        rejected: 'Abgelehnt',
        closed: 'Geschlossen',
        finished: 'Beendet',
        coming: 'Bevorstehend',
        active: 'Laufend',
      },
    },

    selectListings: {
      title: 'Stellenverzeichnis',
      description: 'Wählen Sie die Stellenverzeichnisse aus, in denen das Stellenangebot veröffentlicht werden soll.',
    },

    session: {
      account: 'Kontoverwaltung',
      language: 'Sprache',
      logout: 'Abmelden',
      whatsNew: 'What\'s New',
      trainingMaterial: 'Recright-Schulungen',
      expired: 'Bitte erneut anmelden.',
      showTutorial: 'Tutorial anzeigen',
      helpCenter: 'Recright Help Center',
      organization: 'Organisation',
    },

    showFeedbackPulse: {
      showPulse: 'Feedback zeigen',
      positive: avg => `${avg}% Positiv`,
      feedbackStatistics: 'Feedback-Statistik',
      noFeedback: 'Noch kein Feedback',
      responses: responses => `${responses} Antworten`,
    },

    singleHireUseNotification: {
      notificationHeader: count => `Dir verbleiben ${count} einzelne Einstellungen in Deinem Konto`,
      notificationBody: 'Durch Einladen von Kandidaten oder Veröffentlichen des Interviews wird eine einzelne Einstellung verbraucht.',
    },

    singleHires: {
      currentCount: count => `${count} einzelne Einstellungen verfügbar.`,
      purchase: 'Eine einzelne Einstellung erwerben',
      label: 'Einzelne Einstellung',
      confirmMessage: amount => `Bestätige Deinen Kauf einer einzelnen Einstellung. Deine Kreditkarte wird mit ${amount} EUR belastet.`,
    },

    smartrecruitersPublish: {
      title: 'Integration von Smartrecruiters',
      description: 'Über die Video-Interview-Liste in Smartrecruiters können Sie einzelne Interviews hinzufügen oder entfernen.',
      notification: 'Bitte beachten Sie, dass es bis zu 24 Stunden dauern kann, bis die Interviews in Smartrecruiters angezeigt werden.',
      addButton: 'Zu Smartrecruiters hinzufügen',
      removeButton: 'Aus Smartrecruiters entfernen',
      confirmRemove: 'Sind Sie sicher, dass Sie das Interview aus Smartrecruiters entfernen wollen?',
      addConflict: 'Dieses Interview wurde bereits zur Video-Interview-Liste hinzugefügt',
      removeConflict: 'Dieses Interview wurde bereits aus der Video-Interview-Liste entfernt',
    },

    subscriptionExpired: {
      message: 'Dein Abonnement ist abgelaufen.',
    },

    subscriptionPlan: {
      plan: 'Tarif',
      noActivePlan: 'Du hast keinen aktiven Tarif.',
      changePlan: 'Tarif ändern',
      createSubscription: 'Ein neues Abonnement anlegen',
      save: 'Speichern',
      cancel: 'Abbrechen',
      errorFromProcessor: error => `Der Zahlungsprozessor zeigte folgenden Fehler an: ${error}`,
    },

    stars: {
      yourRating: rating => `Deine Bewertung: ${rating}`,
      totalVotes: count => `Insgesamt ${count} Bewertungen`,
      yourRatingReset: 'Ihre Abstimmung zurücksetzen',
    },

    statisticsFilters: {
      timeframe: 'Timeframe',
      owner: 'Owner',
    },

    csStatisticsFilters: {
      timeframe: 'Timeframe',
      autoSuggestCompany: 'Company name',
      companyId: 'Company ID',
      companyDomain: 'Company domain',
      note: 'Note: ',
      noteText:
        'Company name is case sensitive. Company name suggestions are only shown for companies with > 1 jobads or jobopenings.',
    },

    statisticsSummary: {
      jobCountLabel: 'Open job count',
      interviewsLabel: 'Interviews',
      applicationsLabel: 'Applications',
      answersLabel: 'Interview answers',
      activeUsersLabel: 'Active users',
      avgLeadTimeLabel: 'Average lead time',
      avgLeadTimeValue: value => `${value} days`,
    },

    status: {
      opening: {
        open: 'Offen',
        filled: 'Besetzt',
        cancelled: 'Gekündigt',
        done: 'Fertig',
        close: 'Schließen',
        closed: 'Geschlossen',
        draft: 'Geschlossen (Entwurf)',
        hidden: 'Verborgen',
        unpublished: 'Unveröffentlicht',
      },
      person: {
        hired: 'Eingestellt',
        proceed: 'Fortfahren',
        new: 'Neu',
        videointerviewed: 'Video-Interview',
        personalinterview: 'Persönliches Interview',
        withdrawn: 'Zurückgezogen',
        scheduledinterview: 'Geplantes Vorstellungsgespräch',
        rejected: 'Abgelehnt',
      },
    },

    transactionList: {
      noTransactions: 'Keine Transaktionen',
      createdAt: 'Datum',
      type: 'Typ',
      status: 'Status',
      amount: 'Betrag',
      receipt: 'Beleg',
      statuses: {
        authorization_expired: 'Autorisierung abgelaufen',
        authorized: 'Autorisiert',
        authorizing: 'Wird autorisiert',
        settlement_pending: 'Abwicklung ausstehend',
        settlement_confirmed: 'Abwicklung bestätigt',
        settlement_declined: 'Abwicklung verweigert',
        failed: 'Fehlgeschlagen',
        gateway_rejected: 'Gateway verweigert',
        processor_declined: 'Abwickler verweigert',
        settled: 'Abgewickelt',
        settling: 'In Abwicklung',
        submitted_for_settlement: 'Zur Abwicklung eingereicht',
        voided: 'Aufgehoben',
      },
      types: {
        sale: 'Verkauf',
        credit: 'Gutschrift',
      },
      download: 'Herunterladen',
      downloadReceipt: 'Rechnungsbeleg herunterladen',
      notSettled: 'Warte auf Abwicklung',
    },

    trialBanner: {
      notification: days => `Ihre Testphase endet in ${days} Tagen. Wenn Sie den Service anschließend weiter nutzen möchten, schließen Sie bitte ein Abonnement ab oder erwerben Sie eine einzelne Einstellung.`,
      trialEnded: 'Ihre Testphase ist beendet. Bitte schließen Sie ein Abonnement ab oder erwerben Sie eine einzelne Einstellung, wenn Sie den Service weiter nutzen möchten.',
      orderHere: 'Hier abonnieren!',
    },

    updateCreditCard: {
      save: 'Speichern',
      cancel: 'Abbrechen',
    },

    favorite: {
      popupHeader: 'Videothek auswählen',
      yourVideos: 'Ihre Videos',
      companyVideos: 'Unternehmensvideos',
    },

    FavoritesInfo: {
      Favorites: videoLibrary => `Klicke auf das Herzsymbol, um Videos zu Deinen Favoriten hinzuzufügen. In der <a href="${videoLibrary}">Video-Bibliothek</a> kannst Du Videos aus Deinen Favoriten entfernen.`,
    },

    brandingPreview: {
      preview: 'Voransicht',
      header: 'Musterüberschrift',
      body: lorem => `Das ist die Musterschriftart. ${lorem}`,
      linkText: 'Dies ist ein Musterlink.',
      primaryButtonText: 'Primäre Taste',
      secondaryButtonText: 'Sekundäre Taste',
      backButtonText: 'Zurück-Taste',
    },

    usersList: {
      generalInformation: 'Allgemeine Informationen',
      latestVisit: date => `Letzter Besuch ${date}`,
      neverLogger: 'Hat sich nie angemeldet',
      externalUser: 'Externer Benutzer',
      inviteExpired: 'Einladung ist abgelaufen',
      permissions: {
        permissions: 'Berechtigungen',
        seeAllPositions: 'Alle Stellen ansehen',
        createJobPositions: 'Arbeitsstelle erstellen',
        createInterviews: 'Interviews erstellen',
        account: 'Informationen zum Unternehmen bearbeiten',
        billing: 'Abrechnung',
        reporting: 'Berichtswesen',
        editUsers: 'Benutzer bearbeiten',
        default: 'Standardberechtigungen',
      },
      actions: {
        actions: 'Aktionen',
        activate: 'Aktivieren',
        deactivate: 'Deaktivieren',
        removeFromOrganisation: 'Aus der Organisation entfernen',
        hiddenPositions: 'Ausgeblendete Stellen',
      },
      noUsers: 'Keine Benutzer gefunden. Falls Sie die Liste gefiltert haben, versuchen Sie, weniger Filter anzuwenden.',
    },

    usersListFilters: {
      sort: {
        name: 'Name',
        email: 'E-Mail-Adresse',
        lastAdminAccess: 'Letzter Zugriff durch Admin',
      },
      find: 'Suchen',
      clearSelections: 'Auswahl aufheben',
      usersCount: count => `Insgesamt ${count} Benutzer`,
    },

    usersListActions: {
      editMultipleUsersPermissions: 'Berechtigungen mehrerer Benutzer bearbeiten',
      deactivateSelectedUsers: 'Ausgewählte Benutzer deaktivieren',
      activateSelectedUsers: 'Ausgewählte Benutzer aktivieren',
      addNewUsers: 'Benutzer einladen',
      save: 'Speichern',
      cancel: 'Abbrechen',
      editUsersPermissions: 'Benutzerberechtigungen bearbeiten',
    },

    linkedInInformation: {
      title: 'LinkedIn-Informationen:',
      since: 'Seit',
      summary: 'Zusammenfassung:',
      fullLinkedInProfile: 'Vollständiges LinkedIn-Profil',
    },

    colorPicker: {
      reset: 'Reset',
    },

    emailDeliveryStatus: {
      Undetermined: {
        Undetermined: 'E-Mail wurde zurückgesendet. Stellen Sie sicher, dass der Empfänger Ihre Nachricht erhalten hat.',
      },
      Permanent: {
        General: 'E-Mail-Zustellung fehlgeschlagen. Der E-Mail-Anbieter des Empfängers hat die Nachricht abgelehnt.',
        NoEmail: 'Diese E-Mail-Adresse existiert nicht.',
        Suppressed: 'Die E-Mail konnte aufgrund vorheriger erfolgloser Zustellversuche nicht zugestellt werden.',
      },
      Transient: {
        General: 'E-Mail wurde zurückgesendet. Stellen Sie sicher, dass der Empfänger Ihre Nachricht erhalten hat.',
        MailboxFull: 'Das Postfach des Empfängers ist voll',
        MessageTooLarge: 'Der Inhalt der Nachricht ist zu groß.',
        ContentRejected: 'Der Inhalt der Nachricht wurde abgelehnt.',
        AttachmentRejected: 'Der Anhang wurde abgelehnt.',
      },
    },

    videoBackgroundUpload: {
      header: 'Video-Hintergrundbild des Unternehmens',
      description:
        'Bild, das die Nutzer Ihres Unternehmens als Hintergrundbild für die von ihnen aufgenommenen Videos verwenden können.',
      add: 'Video-Hintergrundbild hinzufügen',
      info: 'Die empfohlene Bildgröße beträgt 720x480 Pixel.',
    },
  },

  page: {
    account: {
      title: 'Kontoverwaltung',
      details: 'Kontoinformationen',
      name: 'Kontoname',
      save: 'Speichern',
      saved: 'Kontoinformationen gespeichert.',
      signature: 'Unterschrift',
      permissions: 'Berechtigungen',
      calendar: {
        label: 'Calendar',
        notAuthorized: 'Authorize your calendar here',
        authorized: 'Edit your calendar authorization',
        revokeError: 'We were unable to unlink your calendar. Please try again later and if the problem persists please contact our support.',
        revokeSuccess: 'Successfully unlinked your calendar',
      },
      password: 'Passwort',
      statistics: 'Statistics',
      organization: 'Organisation',
    },

    actionBar: {
      selection: 'ausgewählt',
    },

    organisationProfile: {
      title: 'Organisationsprofil',
      details: 'Organisationsprofileinstellungen',
      brandingHeader: 'Organisations-Branding',
      name: 'Name der Organisation',
      owner: 'Kontoinhaber',
      customReplyToSubtitle:
        'Hier können Sie den Absendernamen und die Antwortadresse für die Interview-Einladungen bearbeiten. Bleibt dieses Feld leer, werden der Name und die E-Mail-Adresse des Benutzers verwendet, der die Einladungen verschickt.',
      customReplyToEmail: 'Antwort-E-Mail für Interview-Einladungen',
      customReplyToName: 'Absendername für Interview-Einladungen',
      senderInfoDisabled:
        'Die Aktualisierung der Absenderinformationen für die Interview-Einladung ist nicht möglich, da Videointerviews für Ihr Unternehmen deaktiviert sind.',
      slug: 'URL der Karriereseite',
      slugUnavailable: 'Diese URL ist bereits reserviert.',
      slogan: 'Slogan der Karriereseite',
      language: 'Sprache der Karriereseite',
      languagePlaceholder: 'Auswählen',
      rss: 'RSS-Feed Karrieren',
      type: 'Kontotyp',
      types: {
        free: {
          title: 'Kostenlos',
          description: 'Vorteile von kostenlos\n1 Benutzer\nMaximal 1 offenes Stellenangebot',
        },
        basic: {
          title: 'Standard',
          description: 'Vorteile von kostenlos\nUnbegrenzt viele offene Stellenangebote\nVideo-Interviews',
        },
        team: {
          title: 'Team',
          description: 'Vorteile von Team\nUnbegrenzt viele offene Stellenangebote\nVideo-Interviews\nKandidaten-Präsentationen',
        },
      },
      save: 'Speichern',
      reset: 'Reset',
      saved: 'Organisationsdaten wurden gespeichert.',
      companyAdminUsers: 'Company admin users',
      cancel: 'Abbrechen',
      confirmLeave: 'Du hast ungespeicherte Änderungen. Wirklich beenden?',
      error: {
        required: 'Mit einem * Stern gekennzeichnete Felder sind Pflichtfelder.',
      },
      emailBrandingHeader: 'E-Mail-Branding',
      emailBrandingDescription:
        'Passen Sie die Farben der an die Bewerber gesendeten E-Mails an.',
    },

    organisationCompetencies: {
      title: 'Organisationskompetenzen',
      description: 'Hier können Sie Organisationskompetenzen bearbeiten, hinzufügen und löschen. Dies sind die Standardkompetenzen in neuen Positionen, die in diesem Unternehmen geschaffen wurden. Sie finden sie unter Kandidaten in diesen Positionen im Abschnitt "Kompetenzen und Kompatibilität".',
    },

    organisationStages: {
      title: 'Organisation Einstellungsphasen',
      description: 'Hier können Sie Organisationsphasen bearbeiten, hinzufügen, löschen und neu anordnen. Dies sind die Standard-Einstellungsphasen in neuen Stellen, die für dieses Unternehmen geschaffen wurden.',
    },

    organisationEmailTemplates: {
      preview:
        'Vorschau der E-Mail (die Vorschau hat nicht die gesamte Formatierung der endgültigen E-Mail)',
      preview2:
        'Die Farben der E-Mail-Vorlagen können auf der Seite mit den Branding-Einstellungen des Unternehmens angepasst werden',
      timedInterviewPreviewInfo: 'Die Nachricht für das zeitlich begrenzte Video-Interview enthält nicht den Teil über die Kontaktaufnahme mit dem Support.',
      templateTypes: {
        interviewInvite: 'Einladung zum Video-Interview',
        timedInterviewInvite: 'Einladung zum zeitlich begrenztes Video-Interview',
        interviewCompleted:
          'Interview abgeschlossen /  Dankesnachricht für Kandidaten',
        applicationCompleted:
          'Bewerbung abgeschlossen / Dankesnachricht an den Bewerber',
      },
      subHeaders: {
        jobAdLabel: 'Stellenanzeige',
        interviewLabel: 'Videointerview',
      },
      deleteTemplate: 'Vorlage löschen',
      confirmation: templateName =>
        `Sind Sie sicher, dass Sie die Vorlage "${templateName}" aus den E-Mail-Vorlagen Ihres Unternehmens löschen möchten?`,
      deleteSuccess:
        'Die Vorlage wurde aus den E-Mail-Vorlagen des Unternehmens gelöscht.',
      emailTemplateInfo: 'Momentan können Sie nur eine Vorlage mit einer Sprache speichern.',
      templateError: 'Template with same name or language already exists.',
    },

    application: {
      back: 'Zurück zur Bewerbungsliste',
      delete: 'Bewerbung löschen',
      deleted: 'Bewerbung gelöscht',
      interviewClosed: 'Interview ist geschlossen',
      resendInvitation: 'Einladung erneut an Bewerber senden',
      changeStage: 'In andere Phase verschieben',
      commentsAndClassifications: 'Kommentare und Klassifizierungen',
      openingTitle: title => `Video-Interview - ${title}`,
      yourRatingText: 'Deine Bewertung:',
      competencesAndCompatibility: 'Kompetenzen und Kompatibilität',
      duplicateCompetency: 'Kompetenz existiert bereits',
      competencyNotFound: 'Kompetenz nicht gefunden oder entfernt',
      confirmDelete: 'Sind Sie sicher, dass Sie diese Bewerbung löschen wollen?',
      lastSeen: time => `Zuletzt gesehen ${time}.`,
      notVisited: 'Hat das Interview nicht besucht.',
      stageChanged: 'Super!',
      close: 'Schließen',
      reopenProcessConfirm: 'Sind Sie sicher, dass Sie diesen Kandidaten aus der Phase "Zurückgezogen" herausnehmen und wieder in den Einstellungsprozess aufnehmen wollen? Nach der Bestätigung kann der Kandidat wieder auf ein noch nicht abgeschlossenes Interview antworten.',
      withdrawConfirm: 'Sind Sie sicher, dass Sie diesen Kandidaten aus dem Einstellungsprozess herausnehmen wollen? Der Kandidat kann dann keine Interviews mehr beantworten, zu denen er/sie eingeladen wurde.',
      stageChangedInfo: stage => `Nachdem Sie diese Kandidaten nun in die Phase „${stage}“ verschoben haben, können Sie sie per E-Mail oder Videobotschaft darüber informieren.`,
      changestageTooltip: 'Sie können sehen, in welcher Phase sich der Kandidat befindet. Sie können die Phase manuell einstellen, indem Sie auf die entsprechende Phase klicken. Der Kandidat wird darüber nicht informiert.',
      commentsTooltip: 'Sie können Kommentare über die Bewerbung des Kandidaten für Ihre Kollegen hinterlassen. Der Kandidat hat keinen Zugriff auf diese Informationen.',
      competencesTooltip: 'Sie können eine Kompetenz hinzufügen oder bewerten. Ihre Kollegen können die von Ihnen hinzugefügten Kompetenzen sehen und bewerten sowie neue erstellen. Der Kandidat kann diese Informationen nicht sehen.',
      actionlogTooltip: 'Kommentare, Phasenänderungen, Nachrichten und andere Aktivitäten werden hier angezeigt. Der Kandidat kann diese Informationen nicht sehen.',
      state: {
        invited: 'Eingeladen',
        visited: 'Aufgerufen',
        incomplete: 'Unvollständig',
        completed: 'Abgeschlossen',
      },
      stage: {
        new: 'Neu',
        hired: 'Eingestellt',
        proceed: 'Fortfahren',
        personalinterview: 'Persönliches Interview',
        withdrawn: 'Zurückgezogen',
        scheduledinterview: 'Geplantes Vorstellungsgespräch',
        rejected: 'Abgelehnt',
        videointerviewed: 'Video-Interview',
      },
    },

    billing: {
      title: 'Abrechnung',
      nextPayment: (nextBillingPeriodAmount, nextBillingDate) => `Nächste Abrechnung: ${nextBillingPeriodAmount} EUR am ${nextBillingDate}`,
      status: 'Status',
      singleHire: 'Einzelne Einstellung',
      billingOverview: 'Rechnungsübersicht',
      payment: 'Zahlung',
      paymentHistory: 'Zahlungsverlauf',
      updateDetails: 'Rechnungsdaten aktualisieren',
      billingStatus: {
        pending: 'Ausstehend',
        active: 'Aktiv',
        pastdue: 'Überfällig',
        expired: 'Abgelaufen',
        canceled: 'Gekündigt',
      },
      noContractsFound: 'No contracts found. Please contact customer support.',
      monthlyPrice: 'Monthly Price:',
      productName: 'Product Name:',
      products: 'Products',
      nextInvoiceDate: 'Next Invoice Date:',
      monthlyValue: 'Monthly Value:',
      invoiceFrequency: 'Invoice Frequency:',
      months: '(months)',
      nextInvoiceSum: 'Next Invoice Sum:',
      contractStatus: 'Contract Status:',
      contractStartDate: 'Contract Start Date:',
      contractEndDate: 'Contract End Date:',
      termOfNotice: 'Term of Notice:',
      contract: 'Contract',
    },

    candidate: {
      actionLog: 'Aktionsprotokoll',
      back: 'Zurück zur Kandidatenliste',
      delete: 'Kandidaten löschen',
      deleted: 'Kandidat gelöscht',
      interviewClosed: 'Interview ist geschlossen. Es wurden keine Wiedereinladungen versendet.',
      resendInvitation: 'Einladung erneut an Kandidaten senden',
      changeStage: 'In andere Phase verschieben',
      introducedTo: 'Vorgestellt:',
      yourRatingText: 'Deine Bewertung:',
      competencesAndCompatibility: 'Kompetenzen und Kompatibilität',
      duplicateCompetency: 'Kompetenz existiert bereits',
      competencyNotFound: 'Kompetenz nicht gefunden oder entfernt',
      confirmDelete: 'Sind Sie sicher, dass Sie diesen Kandidaten löschen wollen?',
      stageChanged: 'Super!',
      close: 'Schließen',
      stageChangedInfo: stage => `Nachdem Sie diese Kandidaten nun in die Phase „${stage}“ verschoben haben, können Sie sie per E-Mail oder Videobotschaft darüber informieren.`,
      hideStages: 'Phasen verbergen',
      showStages: 'Phasen anzeigen',
      resetQuestionResponseSuccess: 'Die Antwort des Kandidaten wurde gelöscht.',
      stage: {
        new: 'Neu',
        hired: 'Eingestellt',
        proceed: 'Fortfahren',
        personalinterview: 'Persönliches Interview',
        withdrawn: 'Zurückgezogen',
        scheduledinterview: 'Geplantes Vorstellungsgespräch',
        rejected: 'Abgelehnt',
        videointerviewed: 'Video-Interview',
      },
    },

    dashboard: {
      upcomingLiveInterviews: 'Live-Interviews',
      showAllLiveInterviews: 'Alle Live-Interviews anzeigen',
      createNewLiveInterview: 'Neues Live-Interview erstellen',
      welcome: name => `Herzlich willkommen, ${name}!`,
      liveCard: {
        startTime: 'Startzeit',
        interviewers: 'Interviewer',
        candidates: 'Kandidaten',
      },
    },

    interviewEdit: {
      title: 'Interview-Titel',
      titleLabel: 'Titel des Interviews',
      location: 'Standort',
      publishTimePlaceholder: 'Veröffentlichungsdatum',
      publishTimeTooltip: 'Veröffentlichungsdatum für das Interview festlegen. Sie können das Datum jederzeit ändern.',
      endTime: 'Offen bis',
      endTimeTooltip: 'Wählen Sie ein Enddatum für die Bewerbungsfrist.',
      timezone: 'Zeitzone',
      isNotPastDate: 'Datum liegt in der Vergangenheit.',
      interviewIsClosed: 'Das Interview ist derzeit geschlossen. Möchten Sie es ',
      interviewIsClosedLink: 'öffnen',
      edit: {
        details: 'Interview bearbeiten',
        status: 'Interview-Status ändern',
        team: 'Team bearbeiten',
      },
      questions: 'Interview-Fragen',
      answerable: 'Frage kann beantwortet werden',
      questionsDescription: 'Dies sind die Fragen, die die Teilnehmer beantworten sollen.',
      questionsNotEditable: 'Fragen können nicht bearbeitet werden, nachdem die Einladungen versendet wurden.',
      saved: 'Interview gespeichert',
      deleted: 'Interview gelöscht',
      delete: 'Interview löschen',
      cancel: 'Abbrechen',
      save: 'Speichern',
      language: 'Interview-Sprache',
      languagePlaceholder: 'Auswählen',
      confirmLeave: 'Du hast ungespeicherte Änderungen. Wirklich beenden?',
      OnboardingHeadImageSize: 'Die empfohlene Bildgröße für Kopfzeilenbanner beträgt mindestens 1440 x 320 Pixel.',
      takeLimitLabel: 'Anzahl der Aufnahmen',
      answerTimeLabel: 'Antwortzeit',
      preparationTimeLabel: 'Vorbereitungszeit',
      confirmHeader: 'Sind Sie sicher, dass Sie dieses Interview löschen wollen?',
      integratedConfirmContent: 'Dieses Interview ist in ein anderes System integriert und das Löschen kann zu Problemen bei der Integration führen.',
    },

    interview: {
      endTime: date => (date ? `, offen bis ${date}` : ''),
      edit: 'Interview bearbeiten',
      copy: 'Interview kopieren',
      editInvitation: 'Einladungsnachricht bearbeiten',
      editMenu: 'Bearbeiten',
      editTeam: 'Team bearbeiten',
      questions: 'Interview-Fragen',
      changeStatus: 'Interview-Status ändern',
      publishSettings: 'Ausschreibungs-Einstellungen',
      invite: 'Kandidaten einladen',
      showCandidates: 'Kandidaten anzeigen',
      oneError: ' Eingebettetes Interview kann nur eine Frage enthalten.',
      copySuccess: 'Das Interview wurde kopiert.',
      editIntroduceBatches: 'Kandidatenvorstellungen bearbeiten',
      editEmailSettings: 'E-Mail-Einstellungen bearbeiten',
    },

    interviews: {
      allInterviews: 'Alle Video-Interviews',
      createNewVideoInterview: 'Neues Video-Interview erstellen',
      filter: 'Interviews suchen',
      invites: 'Einladungen',
      responses: 'Antworten',
      sort: {
        title: 'Titel',
        endTime: 'Enddatum',
        publishTime: 'Veröffentlichungsdatum',
        createdAt: 'Erstellungsdatum',
        updatedAt: 'Zuletzt geändert',
        answeredCount: 'Kandidaten',
      },
    },

    interviewCandidates: {
      preview: 'Voransicht',
      endTime: date => (date ? `Offen bis ${date}` : ''),
      publicTitle: 'Öffentliches Interview',
      embedTitle: 'Eingebettetes Interview',
      placeholder: {
        first: 'Noch keine Kandidaten.',
        second: 'Sie können auch Ihre Video-Interview öffentlich machen.',
        third: 'Dann kann jeder, der sich für die Position interessiert, das öffentliche Interview sehen und anwenden.',
        fourth: 'Und vergiss nicht, dass all diese Optionen nur einen Klick entfernt in der Titelleiste weiter oben sind.',
      },
      title: 'Alle Kandidaten',
      sort: {
        default: 'Default',
        updatedAt: 'Zuletzt geändert',
        name: 'Name',
        rating: 'Bewertung',
        createdAt: 'Erstellungsdatum',
      },
      sendMessage: 'Nachricht senden',
      changeStage: 'In andere Phase verschieben',
      introduce: 'Vorstellen',
      filter: 'Kandidaten suchen',
      hideFilters: 'Filter ausblenden',
      showFilters: 'Filter anzeigen',
      emailSent: 'E-Mail gesendet!',
      interviewClosedError: 'Sie können einen Kandidaten nicht erneut zu einem geschlossenen Videointerview einladen.',
      excel: 'Alle Kandidaten exportieren',
      reInviteSent: candidates => `${candidates} Wiedereinladungen wurden versendet!`,
    },

    jobAdEdit: {
      preview: 'Vorschau',
      confirm: 'Bist Du sicher, dass Du diese Stelle hinzufügen möchtest?',
      deleteHeader: 'Sind Sie sicher, dass Sie diesen Job entfernen möchten?',
      deleteContent: 'Wenn Sie diesen Job löschen, werden auch alle zugehörigen Informationen wie Bewerbungen und Videointerviews gelöscht.',
      titlePlaceholder: 'Titel der Stelle',
      timezone: 'Zeitzone',
      locationPlaceholder: 'Standort',
      endTimePlaceholder: 'Offen bis',
      endTimeTooltip: 'Wählen Sie ein Enddatum für die Bewerbungsfrist.',
      isNotPastDate: 'Datum liegt in der Vergangenheit.',
      language: 'Sprache',
      publishTimePlaceholder: 'Veröffentlichungsdatum',
      publishTimeTooltip: 'Legen Sie ein Veröffentlichungsdatum für die Stellenausschreibung fest. Sie können das Datum jederzeit ändern.',
      languagePlaceholder: 'Auswählen',
      description: 'Job-Beschreibung',
      saved: 'Stelle gespeichert',
      deleted: 'Stelle gelöscht',
      descriptionPlaceholder: 'Verfasse hier Deine Stellenbeschreibung. \n\nDu kannst die Beschreibung mit den Textwerkzeugen weiter oben bereichern.',
      createInviteOnly: 'Video-Interview (nur auf Einladung) erstellen',
      delete: 'Stelle löschen',
      cancel: 'Abbrechen',
      save: 'Speichern',
      confirmLeave: 'Du hast ungespeicherte Änderungen. Wirklich beenden?',
      singleHireEndError: 'Einzelne Einstellung kann nicht länger als 60 Tage verwendet werden.',
      OnboardingHeadImageSize: 'Die empfohlene Bildgröße für Kopfzeilenbanner beträgt mindestens 1440 x 320 Pixel.',
    },

    jobAdApplications: {
      endTime: date => (date ? `, offen bis ${date}` : ''),
      title: 'Alle Bewerbungen',
      sort: {
        updatedAt: 'Zuletzt geändert',
        name: 'Name',
        rating: 'Bewertung',
        createdAt: 'Erstellungsdatum',
      },
      add: 'Neue Bewerbung erstellen',
      inviteToInterview: 'Zum Interview einladen',
      sendMessage: 'Nachricht senden',
      changeStage: 'In andere Phase verschieben',
      introduce: 'Vorstellen',
      editIntroduceBatches: 'Kandidatenvorstellungen bearbeiten',
      filter: 'Bewerbungen suchen',
      hideFilters: 'Filter ausblenden',
      showFilters: 'Filter anzeigen',
      addInterviewConfirm: jobAd => `Möchten Sie ein neues Videointerview für den Job „${jobAd}” erstellen?`,
    },

    adminJobAdApplication: {
      name: 'Name',
      email: 'E-Mail',
      phone: 'Telefonnummer',
      city: 'Stadt',
      back: 'Zurück',
      continue: 'Weiter',
      submit: 'Hinzufügen',
      namePlaceholder: 'Name des Kandidaten',
      emailPlaceholder: 'E-Mail-Adresse des Kandidaten',
      cityPlaceholder: 'Stadt des Kandidaten',
      links: 'Links hinzufügen, z. B. zum LinkedIn-Profil',
      legendLinks: 'Links',
      legendAttachments: 'Anhänge',
      legendAdditionalFields: 'Zusätzliche Informationen',
      legendBasicInfo: 'Allgemeine Informationen',
      coverLetter: 'Bewerbungsschreiben',
      attachments: 'Anhänge',
      introduction: 'Verfasse hier Deine Kurzvorstellung',
      thankYou: 'Vielen Dank.',
      readyInfo: 'Vielen Dank. Der Kandidat wurde zur offenen Stelle hinzugefügt.',
      close: 'Schließen',
      required: 'Mit einem * Stern gekennzeichnete Felder sind Pflichtfelder.',
      excel: 'Alle Bewerbungen exportieren',
    },

    jobAdPreview: {
      endTime: date => (date ? `, offen bis ${date}` : ''),
      exit: 'Vorschau beenden',
      description: 'Job-Beschreibung',
      video: 'Arbeitgeber-Video',
      questions: 'Video-Frage',
      apply: 'Auf Stelle bewerben',
    },

    jobAd: {
      endTime: date => (date ? `, offen bis ${date}` : ''),
      changeStatus: 'Stellen-Status ändern',
      edit: 'Stelle bearbeiten',
      copy: 'Stellenangebot kopieren',
      editInvitation: 'Einladungsnachricht bearbeiten',
      editMenu: 'Bearbeiten',
      editTeam: 'Team bearbeiten',
      description: 'Job-Beschreibung',
      video: 'Arbeitgeber-Video',
      questions: 'Video-Frage',
      apply: 'Auf Stelle bewerben',
      showApplications: 'Bewerbungen anzeigen',
      publicLink: 'Öffentliche Seite der Stellenanzeige',
      copySuccess: 'Das Stellenangebot wurde kopiert',
    },

    jobAds: {
      subscriptionNeeded: 'Du benötigst ein aktives Abonnement, um dieses Stellenangebot zu veröffentlichen.',
      responses: 'Bewerbungen',
      createNewJobPosition: 'Neues Stellenangebot erstellen',
      allJobPositions: 'Alle Stellenangebote',
      confirmSingleHire: 'Eine Deiner erworbenen einzelnen Einstellungen wird für dieses Stellenangebot verwendet.',
      filter: 'Stellenangebote suchen',
      sort: {
        title: 'Titel',
        publishTime: 'Veröffentlichungsdatum',
        applicationCount: 'Bewerbungen',
        endTime: 'Enddatum',
        createdAt: 'Erstellungsdatum',
        updatedAt: 'Zuletzt geändert',
      },
    },

    jobAdSaved: {
      title: 'Stellenangebot gespeichert!',
      description: 'Deine Stellenanzeige ist jetzt gespeichert. Hier ist ein öffentlicher Link zu der Stellenanzeige:',
      addApplication: 'Direkter Link zum Bewerbungsformular:',
      toDashboard: 'Startseite',
      toJobAd: 'Zurück zur Stellenanzeige',
    },

    live: {
      title: 'Live-Interview',
      editTitle: '"Live-Interview bearbeiten',
      startTimeTitle: 'Interview-Startzeit',
      startTime: 'Startzeit',
      interviewers: 'Interviewer',
      candidates: 'Kandidaten',
      messageLabel: 'Einladungsnachricht',
      create: 'Erstellen',
      save: 'Änderungen speichern',
      cancel: 'Abbrechen',
      removeLive: 'Live-Interview entfernen',
      cancelLive: 'Live-Interview abbrechen',
      comment: 'Neuen Kommentar hinzufügen',
      commentLabel: 'Kommentare',
      enter: 'Live-Interview beitreten',
      edit: 'Teilnehmer hinzufügen/entfernen',
      draft: 'Neues Live-Interview',
      confirmHeader: 'Are you sure you want to delete this live interview?',
      inviteFailure: (success, failed) => `${success} Einladungen gesendet und ${failed} fehlgeschlagen!`,
      inviteSuccess: success => `${success} Einladungen gesendet.`,
      success: {
        create: 'Neues Live-Interview erstellt',
        delete: 'Live-Interview entfernt',
        update: 'Live-Interview aktualisiert',
      },
      placeholders: {
        candidateEmails: 'Kandidaten hinzufügen',
        interviewerEmails: 'Interviewer hinzufügen',
        emailTitle: 'Titel',
        emailMessage: 'Nachricht',
      },
    },

    lives: {
      allLives: 'Alle Live-Interviews',
      createNewLive: 'Neues Live-Interview erstellen',
      filter: 'Nach Kandidaten suchen',
      candidates: 'Kandidaten',
      sort: {
        title: 'Titel',
        startTime: 'Startzeit',
        createdAt: 'Erstellungsdatum',
      },
    },

    login: {
      title: 'Im Dienst anmelden',
      register: 'Registrieren',
      ldap: 'Anmeldung mit LDAP-Integration',
      forgot: 'Passwort vergessen?',
      normal: 'Normale Anmeldung',
      ssoLogin: 'SSO-Anmeldung',
    },

    publicSubscribe: {
      intro: 'Wähle einen geeigneten Tarif, gib Deine Zahlungsinformationen ein, und Du kannst sofort das Video-Einstellungs-Tool verwenden. Sämtliche Deiner Zahlungen werden sicher durch unseren Zahlungsabwickler Braintree verarbeitet.',
      headline: 'Abonnement-Formular',
      header: {
        back: 'Back',
      },
      footer: {
        product: 'Product',
        pricing: 'Pricing',
        resources: 'Resources',
        contact: 'Contact',
        terms: 'User Terms and Conditions',
        privacyPolicy: 'Privacy policy',
        license: 'General Terms of Service',
      },
    },

    publicSubscribeThankYou: {
      title: 'Vielen Dank!',
      existingDescription: 'Wir haben jetzt Deine Abonnement-Informationen erhalten, und Du kannst das Video-Einstellungs-Tool weiterhin verwenden.',
      newUserDescription: 'Wir haben ein Konto für Dich erstellt und per E-Mail Informationen zum Einrichten Deines Passworts versendet.',
    },

    quickInterview: {
      title: 'Kurzes Video-Interview',
      description: 'Um Dich schneller kennenzulernen, möchten wir Dich bitten, kurz auf unsere Interviewfrage zu antworten. Bringe Deine Persönlichkeit zur Geltung und verleihe Deiner Bewerbung eine Seele.',
      requiredNote: 'Bitte beachte, dass dies ein Teil des Bewerbungsverfahrens ist und der Personalverantwortliche deine Bewerbung erst erhält, nachdem du Deine Antwort aufgezeichnet hast.',
      reminderNote: 'Du kannst die Antwort sofort aufnehmen oder später fortfahren, indem Du Dir eine Erinnerung per E-Mail senden lässt.',
    },

    register: {
      title: 'Entwickelt für Recruiter!',
      leadText: 'Recright ist eine benutzerfreundliche Rekrutierungsplattform für Recruiter und Personalverantwortliche. Sie bietet Ihnen die Möglichkeit, Stellenausschreibungen zu veröffentlichen, Bewerbungen zu erhalten und Video-Interviews durchzuführen - alles auf einer Plattform! Unser Tool hat bereits über 400 Unternehmen dabei geholfen, die richtigen Mitarbeiter zu finden und Ihr Unternehmen könnte das Nächste sein! Unten registrieren und mit der Rekrutierung beginnen!',
      email: 'Email',
      submit: 'Registrierung',
      alreadyMember: 'Sie sind bereits Mitglied?',
      onlyForRecruiters: 'Registrierung nur für Recruiter und Personalverantwortliche.',
      login: 'Loggen Sie sich hier ein.',
      registerSuccess: 'Einladungsemail wurde gesendet.',
      domainError: 'Bitte registrieren Sie sich mit Ihrer Firmen-E-Mail-Adresse.',
      companyExistsMessage: 'Überprüfen Sie Ihre E-Mail auf Anweisungen!',
    },

    searchResults: {
      title: 'Suchergebnisse',
      applications: 'Bewerbungen',
      candidates: 'Kandidaten',
      noApplications: 'Keine Bewerbungen entsprechen den Suchkriterien',
      noCandidates: 'Keine Kandidaten entsprechen den Suchkriterien',
      query: query => (query ? `Suchanfrage: ${query}` : ''),
      noStage: 'Noch in keiner Phase',
      search: 'Suchen',
      itemsPerPage: 'Items per page',
    },

    statistics: {
      linkToDetailed: 'See detailed statistics',
      linkToSummary: 'See statistics summary',
      summaryLeadText: 'Figures below comprises of all active positions during the selected time period including the positions that do not have an end date.',
      detailsLeadText: 'This page provides detailed statistics on all positions with any activity during the selected time period.',
      export: 'Export statistics',
      sort: {
        title: 'Titel',
        owner: 'Owner',
        createdAt: 'Erstellungsdatum',
      },
      exportLimit:
        'Too many results. Please reduce the timeframe to enable excel export.',
      tooManyResults:
        'Too many results. Please reduce the timeframe to get results.',
    },

    welcome: {
      title: 'Als Benutzer registrieren',
    },

    welcomeMulticompany: {
      welcome: companyName => `Willkommen bei ${companyName}`,
      successMessage: companyName =>
        `Sie wurden jetzt dem Unternehmen ${companyName} hinzugefügt!`,
      navigationInfo:
        'Sie können Ihr aktuelles Unternehmen über die Navigationsleiste oben rechts ändern.',
      login: 'Loggen Sie sich hier ein',
    },

    forgotPassword: {
      title: 'Neues Kennwort setzen',
      email: 'Email',
      submit: 'Senden',
      sendEmail: 'Senden Sie uns die Email-Adresse, mit der Sie sich bei Recright registriert haben.',
      instructions: 'Wir senden Ihnen dann eine Anleitung, wie Sie Ihr Kennwort ändern können.',
      success: 'Wenn ein Benutzer mit der angegebenen E-Mail-Adresse gefunden wurde, wurden Anweisungen zum ändern des Passworts an diese Adresse gesendet.',
    },

    changePassword: {
      title: 'Kennwort festlegen',
      name: 'Namen',
      email: 'Email',
      password: 'Neues Kennwort',
      confirmPassword: 'Neues Kennwort wiederholen',
      submit: 'Kennwort ändern',
      error: {
        password: {
          isRequired: 'Ein Passwort ist erforderlich. ',
          isValidPassword: 'Das Passwort muss aus mindestens 12 Zeichen bestehen und mindestens einen Groﬂbuchstaben, einen Kleinbuchstaben und eine Ziffer enthalten.',
          passwordsMatch: 'Die Passwörter stimmen nicht überein.',
        },
      },
    },

    ssoLogin: {
      title: 'SSO-Anmeldung',
      description: 'Melden Sie sich mit den Zugangsdaten Ihrer Organisation an.',
      info: 'Die externe Authentifizierung ist nicht konfiguriert. Bitte verwenden Sie den',
      normalLoginLinkText: 'normalen Login.',
      submit: 'Im Dienst anmelden',
    },

    subscribe: {
      title: 'Abonnieren',
      submit: 'Abonnieren',
      creditCard: 'Kreditkarte',
      cvv: 'CVV',
      expirationDate: 'Ablaufdatum',
      vatAdvice: 'Wenn Sie eine Umsatzsteuer-Identifikationsnummer angeben, wird für Ihre Bestellung keine Mehrwertsteuer berechnet.',
      vatId: 'USt-IdNr.',
      vatHelp: 'Gib Deine USt-IdNr. im internationalen Format einschließlich des Ländercodes ein.',
      includeVat: 'inkl. MwSt.',
      firstName: 'Vorname',
      lastName: 'Nachname',
      email: 'E-Mail',
      company: 'Unternehmen',
      street: 'Straße',
      postalCode: 'Postleitzahl',
      city: 'Stadt',
      country: 'Land',
      emptyCardFields: 'Bitte gib Deine Kreditkarten-Informationen an',
      invalidValue: 'Wert des Feldes ist ungültig.',
      planNotSelected: 'Bitte Tarif auswählen',
      totalPrice: 'Gesamt',
      subscribed: 'Super! Dein Abonnement wurde erstellt.',
      subscriptionExists: 'Dein Unternehmen scheint bereits ein aktives Abonnement zu haben. Bitte melde Dich an, um Dein Abonnement zu ändern.',
      agreeTos: 'Ich habe die Nutzungsbedingungen von Recright ',
      agreeTosLinkText: 'gelesen und stimme ihnen zu.',
      privacyPolicy: 'Wir respektieren Ihre Privatsphäre, bitte lesen Sie unsere ',
      privacyPolicyLinkText: 'Datenschutzbestimmungen.',
      licenseAgreement: 'Im Namen des Unternehmens, das ich vertrete, akzeptiere ich die ',
      licenseAgreementLinkText: 'Allgemeinen Geschäftsbedingungen von Recright.',
      newsletter: 'Monatlichen Newsletter abonnieren.',
      neverExpiresDiscount: amount => `Inklusive Laufzeitrabatt von ${amount} EUR`,
      fixedPeriodDiscount: (amount, cycles) => `Inklusive ${amount} EUR Rabatt für ${cycles} Monate`,
      errorFromProcessor: error => `Der Zahlungsprozessor zeigte folgenden Fehler an: ${error}`,
    },

    videos: {
      title: 'Video-Bibliothek',
      add: 'Neues Video erstellen',
      rename: 'Umbenennen',
      remove: 'Entfernen',
      yourVideos: 'Ihre Videos',
      companyVideos: 'Unternehmensvideos',
      sort: {
        createdAt: 'Erstellungsdatum',
        title: 'Titel',
      },

    },

    userManagement: {
      excel: 'Alle Benutzer exportieren',
      title: 'Benutzerverwaltung',
      showCompanyDefaultPermissions: 'Standardberechtigungen des Unternehmens anzeigen',
      activateUserConfirm: 'Wollen Sie diesen Benutzer wirklich aktivieren?',
      deactivateUserConfirm: 'Wollen Sie diesen Benutzer wirklich deaktivieren?',
      showActivatedUsers: 'Aktive Benutzer anzeigen',
      showDeactivatedUsers: 'Deaktivierte Benutzer anzeigen',
      confirmCancelEditPermissions: {
        message: 'Ihre Änderungen wurden nicht gespeichert. Wollen Sie diese Änderungen wirklich verwerfen?',
        cancel: 'Abbrechen',
        confirm: 'Änderungen verwerfen',
      },
      unsavedChanges: 'Ihre Änderungen wurden noch nicht gespeichert. Wollen Sie diese Änderungen speichern?',
      confirm: 'Speichern',
      permissionsChangesSaved: 'Benutzerberechtigungen wurden erfolgreich geändert!',
      userDeactivated: nameOrEmail => `${nameOrEmail} wurde deaktiviert`,
      userActivated: nameOrEmail => `${nameOrEmail} wurde aktiviert`,
      companyDefaultsSaved: 'Standardberechtigungen für Administratoren wurden erfolgreich geändert!',
      usersAddAdded: success => `${success} Benutzer wurden hinzugefügt.`,
      usersAddExist: exist => ` ${exist} Benutzer sind bereits auf Recright.`,
      excel: 'Alle Benutzer exportieren',
    },

  },

}
